import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

class EventcompleteController {
  constructor(
    $http,
    $localStorage,
    $scope,
    $state,
    AuthService,
    CompaniesService,
    EventsService,
    $stateParams,
    SecurityService,
    $rootScope,
    EnvService,
    $timeout,
    $location,
    ngProgressFactory,
    CommonService,
    NgMap,
    TrackingService
  ) {
    this.name = "eventcomplete";
    $localStorage.activeStateName = "events";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$security = SecurityService;
    this.$scope = $scope;
    this.$location = $location;
    this.$companies = CompaniesService;
    this.$progress = ngProgressFactory.createInstance();
    this.$stateParams = $stateParams;
    this.$rootScope = $rootScope;
    this.arrayOfCardErrors = [];
    this.dupe_error_prevent_payment = false;
    this.positions = [];
    this.calcData = 0;
    this.arrayOfCardSuccess = [];
    this.totalMinutesWorkedForEntireJob = 0;
    this.arrayOfEmptyAccounts = null;
    this.$common = CommonService;
    this.bulkCheck = false;
    this.$env = EnvService;
    this.$maps = NgMap;
    this.delivery = false;
    this.sourcingPostTotal = 0;
    this.previousJobblerBeingRated = null;
    this.isTheEventOpen = null;
    this.$timeout = $timeout;
    this.printFriendlyTemplate = null;
    this.$tracking = TrackingService;
    this.checkInMarkers = [];
    this.checkOutMarkers = [];
    this.currentUser = this.$auth.getUserData();
    this.creditCards = this.$auth.getUserData().company.undeletedPaymentInfos;
    this.remain_loading_count = 0;
    this.totalHoursForAllJobblers = 0;
    this.totalForEvent = 0;
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
    this.jobblers = [];
    this.directPayErrorMessage = null;
    this.isDirectPayDisabled = true;
    this.ratingsMap = [];
    this.showRatingsWarningToUser = false;
    this.paymentInfos = this.currentUser.company.undeletedPaymentInfos;
    this.formatPaymentInfoForPage(this.paymentInfos);
    this.ratingsArray = [];
    this.errorWithCard = {status: false, message: ""};
    this.isSuccessJobblerPayment = false;
    this.optionsRating = {value: 5, values: [1, 2, 3, 4, 5]};
    this.optionsRatingModal = {value: 5, values: [1, 2, 3, 4, 5]};
    this.cardsArray = [];
    this.banksArray = [];
    this.getLatestInfo();
    this.add_users_to_team_ui = {
      loading_teams: false,
    };
    this.organizePaymentInfo();
    this.applicationsForBulkUpdate = [];
    this.applicationsForRatingUpdate = [];
    this.do_we_have_teams();

    var _this = this;

    console.log("************COMPLETE");
    console.log("************COMPLETE");
    console.log("************COMPLETE");
    console.dir(_this.$rootScope);
    console.dir(_this.$rootScope.$$listenerCount);

    this.remain_loading_count++;

    this.CollectCardsForConnectListener = this.$rootScope.$on("CollectCardsForConnect", function ($rootscope, event) {
      _this.generateCardsArray();
    });
    this.UpdatedCreditCardConnectionCompletePageListener = this.$rootScope.$on(
      "UpdatedCreditCardConnectionCompletePage",
      function ($rootscope, event) {
        _this.cardsArray = [];
        _this.currentUser = _this.$auth.getUserData();
        _this.paymentInfos = _this.currentUser.company.paymentInfos;
        _this.generateCardsArray();
        _this.organizePaymentInfo();
      }
    );
    this.$scope.$on("$destroy", this.CollectCardsForConnectListener);
    this.$scope.$on("$destroy", this.UpdatedCreditCardConnectionCompletePageListener);
    if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
      _this.currentUser.isAdmin = true;
    }
    this.$events.getEventByIdTrimmedComplete(this.$stateParams.eventId).then(
      function (data) {
        var response = data.data;
        _this.event = response;
        _this.alignSideBar();
        if (_this.event.isSourcingPost) {
          _this.postType = "source";
        } else {
          _this.postType = "regular";
        }
        _this.payRate = _this.event.subEvents[0].deduppedJobbles[0].payPerHour;
        if (_this.event.isClosed === true || _this.event.isCancelled === true || _this.event.isCompleted === true) {
          _this.isTheEventOpen = false;
        } else {
          _this.isTheEventOpen = true;
        }
        _this.remain_loading_count--;
        if (_this.event.status === "error") {
          return;
        }
        $timeout(function () {
          if (_this.event.isClosed === true) {
            //$('eventsidebar .sidebar-nav li:nth-child(5)').removeClass().addClass('active');
            $("eventsidebar .jobs-complete-sidebar ul li:nth-child(5)").removeClass().addClass("active");
          } else {
            $("eventsidebar .sidebar-nav li:nth-child(9)").removeClass().addClass("active");
          }
        }, 2000);
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetEventToEventDialog", {
            event: _this.event,
          });
          _this.$rootScope.$emit("SetEventToEventSidebar", {
            event: _this.event,
          });
        });
        _this.remain_loading_count++;
        $timeout(function () {
          _this.formatAddressForMaps();
        }, 3000);
        _this.getAcceptedJobblers();
        _this.checkForDelivery();
      },
      function (data) {
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );

    $timeout(function () {
      _this.printFriendlyTemplate = "<table><thead><th>Name</th><th>Email</th><th>Number</th></thead>";
      var endOfTable = "</tbody></table>";
      var arrayOfRows = [];
      var stringOfHtml = "";
      if (_this.jobblers) {
        try {
          for (var i = 0; i < _this.jobblers.length; i++) {
            arrayOfRows.push(
              "<tr><td>" +
                _this.jobblers[i].applicant.firstName +
                " " +
                _this.jobblers[i].applicant.lastName +
                "</td><td>" +
                _this.jobblers[i].applicant.email +
                "</td><td>" +
                _this.jobblers[i].applicant.homeContactInfo.phoneMobile +
                "</td></tr>"
            );
            _this.printFriendlyTemplate =
              _this.printFriendlyTemplate +
              "<tr><td>" +
              _this.jobblers[i].applicant.firstName +
              " " +
              _this.jobblers[i].applicant.lastName +
              "</td><td>" +
              _this.jobblers[i].applicant.email +
              "</td><td>" +
              _this.jobblers[i].applicant.homeContactInfo.phoneMobile +
              "</td></tr>";
          }
        } finally {
          _this.printFriendlyTemplate = _this.printFriendlyTemplate + endOfTable;
        }
      }
    }, 4000);

    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function () {
      _this.$state.go("jobsdashboard");
    });

    _this.UpdatedCreditCardListener = _this.$rootScope.$on("UpdatedCreditCard", function ($rootscope, params) {
      _this.$auth.reloadCurrentUser();

      if (params) {
        _this.formatPaymentInfoForPage(params.user.company.undeletedPaymentInfos);
      } else {
        _this.$timeout(function () {
          _this.currentUser = _this.$auth.getUserData();
          _this.creditCards = _this.currentUser.company.undeletedPaymentInfos;
          _this.generateCardsArray();
        }, 4000);
      }
    });

    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
    _this.$scope.$on("$destroy", _this.UpdatedCreditCardListener);
  }

  getCheckInLocationData(applications) {
    var _this = this;
    var arrayOfAllShiftsThatHaveCheckInCoords = [];
    applications.forEach(function (app) {
      app.jobble.shifts.forEach(function (shift) {
        if (!_this.$security.isUndefinedOrNull(shift.checkInCoord)) {
          shift.checkInCoord.jobbleId = app.jobble.id;
          shift.checkInCoord.shiftId = shift.id;
          arrayOfAllShiftsThatHaveCheckInCoords.push(shift);
        } else {
          arrayOfAllShiftsThatHaveCheckInCoords.push(shift);
        }
      });
    });
    if (arrayOfAllShiftsThatHaveCheckInCoords.length != 0) {
      _this.loopShiftsWithCheckinCordsSlowly(arrayOfAllShiftsThatHaveCheckInCoords);
    }
  }

  loopShiftsWithCheckinCordsSlowly(shifts) {
    var _this = this;
    shifts.forEach(function (shift, i) {
      (function () {
        setTimeout(function () {
          if (shift.checkInCoord) {
            var myLatLng = {
              lat: shift.checkInCoord.lat,
              lng: shift.checkInCoord.lng,
            };
            var geocoderPerApp = new google.maps.Geocoder();
            geocoderPerApp.geocode({latLng: myLatLng}, function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                  shift.checkInAddress = results[0].formatted_address;
                } else {
                  shift.checkInAddress = "Address not recognized by google";
                }
              } else {
                shift.checkInAddress = "Address not recognized by google";
              }
            });
          }
          if (i + 1 === shifts.length) {
            _this.loopShiftsWithCheckoutCordsSlowly(shifts);
          }
        }, i * 300);
      })(shift);
    });
  }

  loopShiftsWithCheckoutCordsSlowly(shifts) {
    var _this = this;
    shifts.forEach(function (shift, i) {
      (function () {
        setTimeout(function () {
          if (shift.checkOutCoord) {
            var myLatLng = {
              lat: shift.checkOutCoord.lat,
              lng: shift.checkOutCoord.lng,
            };
            var geocoderPerApp = new google.maps.Geocoder();
            geocoderPerApp.geocode({latLng: myLatLng}, function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {
                if (results[1]) {
                  shift.checkOutAddress = results[0].formatted_address;
                } else {
                  shift.checkOutAddress = "Address not recognized by google";
                }
              } else {
                shift.checkOutAddress = "Address not recognized by google";
              }
            });
          }
          if (i + 1 === shifts.length) {
            _this.putTheCordsBackInTheirShifts(shifts);
          }
        }, i * 300);
      })(shift);
    });
  }

  putTheCordsBackInTheirShifts(shifts) {
    var _this = this;
    _this.jobblers.forEach(function (application, i) {
      application.jobble.shifts.forEach(function (existingShift) {
        shifts.forEach(function (newShift) {
          if (newShift.id === existingShift.id) {
            existingShift.checkInAddress = newShift.checkInAddress;
            existingShift.checkOutAddress = newShift.checkOutAddress;
          }
        });
      });
      if (i + 1 === _this.jobblers.length) {
        _this.$timeout(function () {
          _this.jobblers = _this.jobblers;
          _this.tableLoader = false;
        }, 1000);
      }
    });
  }

  setEditStatus() {
    var _this = this;
    _this.infoForDisplay.isEditStatus = true;
  }

  figureOutTheTime(minutes) {
    var _this = this;
    var timeObj = {};
    var hours = Math.floor(minutes / 60);
    var mins = minutes % 60;
    timeObj.hours = hours;
    timeObj.minutes = mins;
    return timeObj;
  }

  timeForTable(minutes) {
    var _this = this;
    var hours = Math.floor(minutes / 60);
    var mins = _this.showLeadingZero(minutes % 60);
    return hours + ":" + mins;
  }

  countChars() {
    var _this = this;

    if (_this.reviewForBulk) {
      _this.count = _this.reviewForBulk.length;
    } else {
      _this.count = 0;
    }
  }

  countCharsBulk() {
    var _this = this;
  }

  displayApplicantInfo(application, status, index) {
    var _this = this;

    _this.reviewForBulk = null;
    _this.count = 0;

    if (status === 1) {
      if (application.ratingReview) {
        _this.reviewForBulk = application.ratingReview;
      }
      _this.$timeout(function () {
        jQuery("#modal-add-review-jobbler").modal();
      });
    }

    if (application.show) {
      _this.slidePayments(application, index);
    }

    _this.remain_loading_count = 1;

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetLoaderDialog", {type: 1, total: 1});
    });

    this.displayDetails = true;
    this.userWantsShifts = false;
    this.ratingOption = application.rating.rate;
    this.editByShift = false;

    if (_this.positions) {
      _this.positions = [];
    }

    if (application.shift_count > 1 && application.jobble.actualMinutesWorked) {
      application.displayTimeEditingWardning = true;
    }

    this.$events.getShiftInformationComplete(_this.event.subEvents[0].id, application).then(function (response) {
      application.jobble.shifts = response.data.jobble.shifts;

      if (_this.$security.isUndefinedOrNull(application.jobble.actualMinutesWorked)) {
        ////console.log('just want to make sure');

        if ((application.jobble.jobbleDurationInMinutes / 60) % 1 !== 0) {
          var timeObj = _this.figureOutTheTime(application.jobble.jobbleDurationInMinutes);

          _this.hourPreview = timeObj.hours;
          _this.minutePreview = timeObj.minutes;
        } else {
          _this.hourPreview = application.jobble.jobbleDurationInMinutes / 60;
          _this.minutePreview = 0;
        }
      } else {
        timeObj = _this.figureOutTheTime(application.jobble.actualMinutesWorked);
        _this.hourPreview = timeObj.hours;
        _this.minutePreview = timeObj.minutes;
      }

      try {
        application.totalPaymentsForJobble = 0;
        application.totalNumberOfPaymentsForJobble = 0;

        _this.shiftsWithPayments = [];
        _this.shiftsWithOutPayments = [];

        application.jobble.shifts.forEach(function (shift) {
          if (shift.paymentStats.number > 0) {
            _this.shiftsWithPayments.push(shift);
          } else {
            _this.shiftsWithOutPayments.push(shift);
          }

          if (shift.paymentStats) {
            application.totalPaymentsForJobble = application.totalPaymentsForJobble + shift.paymentStats.amount;
          }

          if (shift.paymentStats.number) {
            application.totalNumberOfPaymentsForJobble = application.totalNumberOfPaymentsForJobble + shift.paymentStats.number;
          }

          shift.timeInterval.startTimeFormattedTZ = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
          shift.timeInterval.startDateFormattedTZ = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY");
          shift.timeInterval.endTimeFormattedTZ = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");

          var momentET = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId);
          var momentST = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId);

          var totalMinutes = null;
          var hoursRounded = null;

          if (shift.actualMinutesWorked || shift.actualMinutesWorked === 0) {
            totalMinutes = shift.actualMinutesWorked;
            hoursRounded = Math.floor(totalMinutes / 60);
          } else {
            totalMinutes = shift.shiftDurationInMinutes = momentET.diff(momentST, "minutes");
            hoursRounded = Math.floor(totalMinutes / 60);
          }

          shift.shiftDurationInHours = hoursRounded;
          shift.shiftDurationInMinutes = totalMinutes % 60;

          if (!shift.paymentStats.amount) {
            shift.amountPaid = 0;
          } else {
            if (!shift.noShow) {
              shift.paidOutClass = "success-payment-shifts";
              shift.amountPaid = shift.paymentStats.amount;
            }
          }

          if (!_this.$security.isUndefinedOrNull(shift.checkInTime)) {
            //shift.checkInTimeForView = moment(shift.checkInTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY") + " at " + moment(shift.checkInTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
            shift.checkInTimeForView = moment(shift.checkInTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
          } else {
            // shift.checkInTimeForView = "---";
            shift.checkInTimeForView = null;
          }
          if (!_this.$security.isUndefinedOrNull(shift.checkOutTime)) {
            //shift.checkOutTimeForView = moment(shift.checkOutTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY") + " at " + moment(shift.checkOutTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
            shift.checkOutTimeForView = moment(shift.checkOutTime).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
          } else {
            shift.checkOutTimeForView = null;
          }

          if (!_this.$security.isUndefinedOrNull(shift.autoCheckInCoord.dateCreated)) {
            //shift.autoCheckInTimeForView = moment(shift.autoCheckInCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("MMM DD, YYYY") + " at " + moment(shift.autoCheckInCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
            shift.autoCheckInTimeForView = moment(shift.autoCheckInCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
          } else {
            shift.autoCheckInTimeForView = null;
          }

          if (!_this.$security.isUndefinedOrNull(shift.autoCheckOutCoord.dateCreated)) {
            //shift.autoCheckOutTimeForView = moment(shift.autoCheckOutCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("MMM DD, YYYY") + " at " + moment(shift.autoCheckOutCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
            shift.autoCheckOutTimeForView = moment(shift.autoCheckOutCoord.dateCreated).tz(shift.contactInfo.place.timeZoneId).format("hh:mm A");
          } else {
            shift.autoCheckOutTimeForView = null;
          }
        });
      } finally {
        application.hoursEdited = 0;
        application.minutesEdited = 0;

        _this.infoForDisplay = application;
        _this.setMarkerToMap(application);

        application.jobble.shifts.sort(function (a, b) {
          return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
        });

        if (_this.infoForDisplay.noShowClass) {
          _this.infoForDisplay.jobble.paidOutClass = "jobbler-is-no-show";
          _this.minutePreview = 0;
          _this.hourPreview = 0;
        }

        _this.$timeout(function () {
          _this.$rootScope.$emit("SetLoaderDialog", {
            type: 0,
            total: 1,
          });
        });

        _this.remain_loading_count = 0;
        _this.calculateTotalsForDisplay();
        _this.setShiftStartTimesAndAmounts(application);

        if (application.jobble.noShow && application.jobble.shifts.length === 1 && !application.jobble.shifts.noShow) {
          _this.markJobblerShowShowForShift(application.jobble.shifts[0], true, true);
        }
      }
    });
  }

  displayShiftInfo(application) {
    this.infoForDisplay = application;
  }

  printRoster() {
    var _this = this;

    if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
      var popupWin = window.open("", "_blank", "width=800,height=800,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no");
      popupWin.window.focus();
      popupWin.document.write(
        "<!DOCTYPE html><html><head>" +
          '<link rel="stylesheet" type="text/css" href="/app/vendor/css/style-print.css" />' +
          '</head><body onload="window.print()"><div class="print-body">' +
          _this.printFriendlyTemplate +
          "</div></html>"
      );
      popupWin.onbeforeunload = function (event) {
        popupWin.close();
        return ".\n";
      };
      popupWin.onabort = function (event) {
        popupWin.document.close();
        popupWin.close();
      };
    }
  }

  selectedCardInfo(card, event) {
    this.payType = "card";
    this.errorWithCard.status = false;
    this.cardHasBeenSelected = true;
    this.token = card.cardToken;
  }

  selectedBankInfo(bank, event) {
    ////.log('selectedBankInfo');
    ////.dir(bank);
    this.payType = "bank";
    this.cardHasBeenSelected = true;
    this.token = bank.stripeId;
  }

  manageRatings(userApp) {
    var _this = this;
    _this.showRatingError = false;

    this.ratingOption = userApp.ratingValue;

    if (!this.$security.isUndefinedOrNull(this.ratingOption) && this.ratingOption !== 0) {
      this.jobblers.forEach(function (jobblerLoop) {
        if (jobblerLoop.applicant.id === userApp.applicant.id) {
          jobblerLoop.ratingValue = _this.ratingOption;
          jobblerLoop.displaySticky = true;
          var ratingsArray = [];
          var ratingsObjForDB = {};
          ratingsObjForDB.ratingUser = _this.currentUser.id;
          ratingsObjForDB.ratedUser = userApp.applicant.id;
          ratingsObjForDB.rate = _this.ratingOption;
          ratingsObjForDB.noteRateGiver = _this.review;
          ratingsObjForDB.ratingType = 1;
          ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
          ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
          ratingsArray.push(ratingsObjForDB);
          _this.ratingsMap.push(userApp);

          var submitRating = {
            method: "POST",
            url: _this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web&fields=rate",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + _this.currentUser.access_token,
            },
            data: {ratings: ratingsArray},
          };

          _this.remain_loading_count++;
          _this.$http(submitRating).then(
            function (response) {
              if (response.status === "error") {
                _this.displayDetails = false;
                _this.ratingOption = null;
                _this.review = null;
                _this.remain_loading_count--;
              } else {
                userApp.ratingValue = response.data[0].rate;
                _this.displayDetails = false;
                _this.ratingOption = null;
                _this.review = null;
                if (_this.ratingsMap.length >= _this.jobblers.length) {
                  _this.showRatingsWarningToUser = false;
                  if (!_this.$security.isUndefinedOrNull(_this.token)) {
                    _this.cardHasBeenSelected = true;
                  }
                }

                for (var i = 0; i < _this.ratingsArray.length; i++) {
                  if (userApp.applicant.id === _this.ratingsArray[i].ratedUser) {
                    _this.ratingsArray[i].rate = ratingsObjForDB.rate;
                  }
                }

                _this.remain_loading_count--;

                _this.$timeout(function () {
                  jQuery("#modal-add-review-jobbler .modal-header button.close").trigger("click");
                });
              }
            },
            function (response) {
              _this.remain_loading_count--;
              //////.log(response.data);
              _this.$timeout(function () {
                jQuery("#show-application-alert").trigger("click");
              }, 100);
            }
          );
        }
      });
    } else {
      this.showRatingError = true;
    }
  }

  noShow(jobbler) {
    //////.log('no show');
    //////.dir(jobbler);
    this.jobblerForNoShowPopUp = jobbler;
    this.displayNoShowModal = true;
    this.displayShiftDetails = false;

    var _this = this;
    jobbler.jobble.noShow = true;
    _this.remain_loading_count++;

    jQuery("#modal-jobble-shift .modal-header button.close").trigger("click");

    var putNowShow = {
      method: "PUT",
      url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbler.jobble.id + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {noShow: true},
    };

    _this.$http(putNowShow).then(
      function (response) {
        _this.remain_loading_count--;
        if (response.status === "error") {
          //////.log('no show not put');
          _this.displayNoShowModal = false;
          //////.dir(response);
        } else {
          //////.log('no show put');
          //////.dir(response);
          _this.displayNoShowModal = false;
          jobbler.ratingValue = 1;
          jobbler.noShowClass = "no-show-jobbler";

          if (jobbler.jobble.actualMinutesWorked === null || jobbler.jobble.actualMinutesWorked === 0) {
            if (jobbler.jobble.jobbleDuration === 0) {
              _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers - jobbler.jobble.jobbleLength;
              _this.totalForEvent -= jobbler.jobble.payPerHour * jobbler.jobble.jobbleLength;
            } else {
              _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers - jobbler.jobble.jobbleDuration;
              _this.totalForEvent -= jobbler.jobble.payPerHour * jobbler.jobble.jobbleDuration;
            }
          } else {
            _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers - jobbler.jobble.actualMinutesWorked / 60;
            _this.totalForEvent -= jobbler.jobble.payPerHour * (jobbler.jobble.actualMinutesWorked / 60);
          }

          // jobbler.jobble.actualMinutesWorked = 0;

          _this.ratingsMap.push(jobbler);
          var ratingsArrayForNoShow = [];
          var ratingsObjForDBForNoShow = {};
          ratingsObjForDBForNoShow.ratingUser = _this.currentUser.id;
          ratingsObjForDBForNoShow.ratedUser = jobbler.applicant.id;
          ratingsObjForDBForNoShow.rate = 1;
          ratingsObjForDBForNoShow.noteRateGiver = "Did not show up for work.";
          ratingsObjForDBForNoShow.ratingType = 1;
          ratingsObjForDBForNoShow.subEvent = jobbler.jobble.subEventId;
          ratingsObjForDBForNoShow.ratingCompany = _this.currentUser.company.id;
          ratingsArrayForNoShow.push(ratingsObjForDBForNoShow);

          var submitRatingForNoShow = {
            method: "POST",
            url: _this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + _this.currentUser.access_token,
            },
            data: {ratings: ratingsArrayForNoShow},
          };

          _this.remain_loading_count++;

          _this.$http(submitRatingForNoShow).then(
            function (response) {
              _this.remain_loading_count--;
              if (response.status === "error") {
                //////.log('rating not upserted');
                //////.dir(response);
              } else {
                //////.log('rating upserted');
                //////.dir(response);
                if (_this.ratingsMap.length >= _this.jobblers.length) {
                  _this.showRatingsWarningToUser = false;
                }
              }
            },
            function (data) {
              _this.remain_loading_count--;
              _this.$timeout(function () {
                jQuery("#show-application-alert").trigger("click");
              }, 100);
            }
          );
        }
      },
      function (data) {
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  noShowCancel(jobbler) {
    var _this = this;

    _this.displayNoShowCancelModal = true;
    _this.jobblerForNoShowPopUpCancel = jobbler;
    _this.displayShiftDetails = true;
    _this.displayShiftDetails = false;

    //////.log('before...');
    //////.dir(jobbler);
    jobbler.ratingValue = 5;
    jobbler.noShowClass = undefined;
    //////.log('after...');
    //////.dir(jobbler);
    jQuery("#modal-jobble-shift .modal-header button.close").trigger("click");
    var putNowShowCancel = {
      method: "PUT",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + jobbler.jobble.id + "?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {noShow: false},
    };

    _this.remain_loading_count++;
    _this.$http(putNowShowCancel).then(
      function (response) {
        if (response.status === "error") {
          //////.log('no show not put');
          _this.displayNoShowCancelModal = false;
          //////.dir(response);
        } else {
          _this.displayNoShowCancelModal = false;

          jobbler.jobble.noShow = false;
          if (_this.$security.isUndefinedOrNull(jobbler.jobble.jobbleLength)) {
            jobbler.jobble.jobbleLength = jobbler.jobble.jobbleDuration;
            _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers + jobbler.jobble.jobbleDuration;
            _this.totalForEvent += jobbler.jobble.payPerHour * jobbler.jobble.jobbleDuration;
          } else {
            _this.totalHoursForAllJobblers = _this.totalHoursForAllJobblers + jobbler.jobble.jobbleLength;
            _this.totalForEvent += jobbler.jobble.payPerHour * jobbler.jobble.jobbleLength;
          }

          var ratingsArrayForNoShow = [];
          var ratingsObjForDBForNoShow = {};
          ratingsObjForDBForNoShow.ratingUser = _this.currentUser.id;
          ratingsObjForDBForNoShow.ratedUser = jobbler.applicant.id;
          ratingsObjForDBForNoShow.rate = 5;
          ratingsObjForDBForNoShow.noteRateGiver = "";
          ratingsObjForDBForNoShow.ratingType = 1;
          ratingsObjForDBForNoShow.subEvent = jobbler.jobble.subEventId;
          ratingsObjForDBForNoShow.ratingCompany = _this.currentUser.company.id;
          ratingsArrayForNoShow.push(ratingsObjForDBForNoShow);

          var submitRatingForNoShowCancel = {
            method: "POST",
            url: _this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + _this.currentUser.access_token,
            },
            data: {ratings: ratingsArrayForNoShow},
          };

          _this.remain_loading_count++;

          _this.$http(submitRatingForNoShowCancel).then(
            function (response) {
              _this.remain_loading_count--;
              if (response.status === "error") {
                //////.log('rating not upserted');
                //////.dir(response);
              } else {
                //////.log('rating upserted');
                //////.dir(response);
                if (_this.ratingsMap.length >= _this.jobblers.length) {
                  _this.showRatingsWarningToUser = false;
                  _this.remain_loading_count = 0;
                }
              }
            },
            function (data) {
              _this.remain_loading_count--;
              _this.$timeout(function () {
                jQuery("#show-application-alert").trigger("click");
              }, 100);
            }
          );
        }

        _this.remain_loading_count--;
      },
      function (data) {
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  updateJobblerInfo(application) {
    //////.dir(application);
    var _this = this;
    if (!_this.$security.isUndefinedOrNull(application.hoursEdited)) {
      var hoursToMinutes = application.hoursEdited * 60;
      //////.log('hours converted');
      //////.dir(hoursToMinutes);

      if (!_this.$security.isUndefinedOrNull(application.minutesEdited)) {
        //////.log('were the minutes edited?');
        //////.dir(hoursToMinutes);
        //////.dir(application.minutesEdited);

        hoursToMinutes = hoursToMinutes + application.minutesEdited;
        //////.log('minutes converted');
        //////.dir(hoursToMinutes);
      }

      application.jobble.actualMinutesWorked = hoursToMinutes;

      //////.log('right before the put');
      //////.dir(hoursToMinutes);
      //////.dir(application.jobble.actualMinutesWorked);

      var putActualHoursWorked = {
        method: "PUT",
        url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/" + application.jobble.id + "?format=json&conf=web",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {actualMinutesWorked: hoursToMinutes},
      };

      _this.remain_loading_count++;
      _this.$http(putActualHoursWorked).then(
        function (response) {
          _this.remain_loading_count--;
          if (response.data.status === "error") {
            application.hoursEdited = 0;
            application.minutesEdited = 0;
            application.isEditStatus = false;
          } else {
            application.displayShiftDetails = false;
            application.hoursEdited = 0;
            application.minutesEdited = 0;
            try {
              _this.jobblers.forEach(function (jblr) {
                if (jblr.applicant.id === application.applicant.id) {
                  jblr.jobble.actualMinutesWorked = hoursToMinutes;
                  jblr.jobble.jobbleDurationInMinutes = hoursToMinutes;
                  jblr.jobble.actualRevenue = (hoursToMinutes / 60) * jblr.jobble.payPerHour;
                  jblr.jobble.costOfJobble = (hoursToMinutes / 60) * jblr.jobble.payPerHour;
                }
              });
            } finally {
              _this.calculateCostOfEventAfterEdit();
              jQuery("#modal-jobble-shift .modal-header button.close").trigger("click");
            }
          }
        },
        function (response) {
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    }
  }

  calculateCostOfEventAfterEdit() {
    var _this = this;
    _this.totalForEvent = 0;
    var tempTotal = 0;
    var tempHours = 0;
    _this.jobblers.forEach(function (jobbler) {
      tempHours = 0;
      if (jobbler.jobble.noShow !== true) {
        if (jobbler.jobble.actualMinutesWorked !== null) {
          tempHours = jobbler.jobble.actualMinutesWorked / 60;
        } else {
          if (jobbler.jobble.jobbleLength % 1 !== 0) {
            tempHours = parseFloat(jobbler.jobble.jobbleLength);
          } else {
            tempHours = parseFloat(jobbler.jobble.jobbleLength);
          }
        }
      }
      tempTotal = tempTotal + tempHours;

      _this.totalForEvent += tempHours * jobbler.jobble.payPerHour;
    });

    _this.totalHoursForAllJobblers = tempTotal;
  }

  submitPaymentModal(status, reTriggerModal) {
    var _this = this;

    let not_checked_array = [];

    if (_this.paymentMethodsFormatted.length === 0 && _this.currentUser.company.payByInvoice !== true) {
      _this.displayPaymentInfoModal();
      return;
    }

    try {
      _this.jobblers.forEach(function (jobbler) {
        if (!jobbler.isCheckedForAction && !jobbler.jobble.noShow && !jobbler.paymentToshiftHasBeenMade) {
          not_checked_array.push(jobbler);
        }
      });
    } finally {
      _this.not_checked_array = not_checked_array;
    }
    _this.paymentAttempted = true;

    console.log("_this.cardHasBeenSelected");
    console.dir(_this.paymentAttempted);
    console.dir(_this.cardHasBeenSelected);

    if (_this.cardHasBeenSelected && _this.paymentAttempted) {
      _this.noCardSelectedError = false;

      if (reTriggerModal !== false) {
        //_this.checkForDuplicatePayments();
      }

      if (status === 1) {
        _this.$timeout(function () {
          jQuery("#modal-complete-event-confirm-modal").modal();
          _this.completeModalMessage = "Please confirm that you want to pay out this job";
          _this.completeButton = "Confirm";
        }, 100);
      }
      if (status === 2) {
        _this.$timeout(function () {
          jQuery("#modal-complete-event-confirm-modal").modal();
          _this.completeModalMessage =
            "There seems to have been an error processing your request. Please contact support for further assitance at high-five@jobbleapp.com.";
          _this.completeButton = "OK";
        }, 100);
      }
    } else {
      if (_this.currentUser.company.payByInvoice === true) {
        console.log("what about here");
        if (reTriggerModal !== false) {
          //_this.checkForDuplicatePayments();
        }
        _this.$timeout(function () {
          jQuery("#modal-complete-event-confirm-modal").modal();
          _this.completeModalMessage = "Please confirm that you want to pay out this job";
          _this.completeButton = "Confirm";
        }, 100);
      } else {
        _this.noCardSelectedError = true;
      }
    }
  }

  checkForDuplicatePayments() {
    var _this = this;

    console.log("_this.checkForDuplicatePayments();");
    console.dir(_this.jobblers);

    let jobblersForWarning = [];

    try {
      _this.jobblers.forEach(function (item, index) {
        if (item.isCheckedForAction === true) {
          console.log("checked jobblers");
          console.dir(item);
          jobblersForWarning.push(item);
        }
      });
    } catch (err) {
      console.log("in error catch");
      console.dir(err);
    } finally {
      console.log("in the finally");
      console.dir(jobblersForWarning);
      _this.checkForPaymentStats(jobblersForWarning);
    }
  }

  checkForPaymentStats(jobblers) {
    var _this = this;

    console.log("checkForPaymentStats");
    console.dir(jobblers);

    let usersForWarning = [];

    try {
      jobblers.forEach(function (app) {
        app.jobble.shifts.forEach(function (shift) {
          console.log("each shift shift");
          console.dir(shift);
          if (shift.paymentStats.amount !== null) {
            console.log("we have payment stats");
            console.dir(shift);
            usersForWarning.push(app);
          }
        });
      });
    } catch (err) {
      console.log("error");
      console.dir(err);
    } finally {
      console.log("in the finally");
      console.dir(usersForWarning.length);
      console.dir(usersForWarning);

      if (usersForWarning.length > 0) {
        console.log("in the if statement....");

        _this.$timeout(function () {
          jQuery("#modal-complete-event-confirm-modal").modal("toggle");
        }, 800);

        _this.$timeout(function () {
          _this.usersForWarning = usersForWarning;
          jQuery("#modal-complete-event-attention-modal").modal();
        }, 1200);
      }
    }
  }

  triggerPaymentModal() {
    var _this = this;

    _this.submitPaymentModal(1, false);
  }

  submitPayment() {
    this.showPaymentLoaderButton = undefined;
    this.errorWithCard = {};
    this.errorWithCard.status = false;
    this.isSuccessJobblerPayment = false;

    var _this = this;

    _this.$timeout(function () {
      jQuery("#modal-complete-loader-event-confirm").trigger("click");
    }, 100);

    _this.$rootScope.loadingWalkThrough = {};
    _this.$progress.start();

    if (!_this.creditCards && _this.currentUser.company.payByInvoice !== true) {
      _this.errorWithCard.status = true;
      _this.errorWithCard.message = "Can't pay the jobbler because there is no any credit card.";
      _this.$progress.complete();
      alert("There is no payment menthod on file.");
      return;
    }

    if (_this.creditCards.length === 0 && _this.currentUser.company.payByInvoice !== true) {
      _this.errorWithCard.status = true;
      _this.errorWithCard.message = "Can't pay the jobbler because there is no any credit card.";
      _this.$progress.complete();
      alert("There is no payment menthod on file.");
      return;
    }

    if (!_this.cardHasBeenSelected && _this.currentUser.company.payByInvoice !== true) {
      _this.errorWithCard.status = true;
      _this.errorWithCard.message = "Please select a credit card to pay the jobbler.";
      _this.$progress.complete();
      alert("There was no payment menthod selected.");
      return;
    }

    if (_this.$security.isUndefinedOrNull(this.token) && _this.currentUser.company.payByInvoice !== true) {
      _this.errorWithCard.status = true;
      _this.errorWithCard.message = "There is no token for this card. Please select or register another card";
      _this.$progress.complete();
      alert("There is no token for this card. Please select or register another card");
      return;
    }

    _this.remain_loading_count++;
    _this.$rootScope.loadingWalkThrough.status = true;
    _this.$rootScope.loadingWalkThrough.message = "Paying jobblers...Do not refresh page.";

    let u = _this.currentUser;

    console.log("what is the user");
    console.dir(u);

    let paymentRequst = _this.$events.payJobblersAndCloseEvent(
      _this.jobblers,
      _this.subeventIdForClosure,
      _this.token,
      _this.$stateParams.eventId,
      _this.payType,
      _this.delivery,
      u
    );

    console.log("paymentRequst");
    console.dir(paymentRequst);

    paymentRequst.then(
      function (paymentResponse) {
        console.log("paymentResponse");
        console.dir(paymentResponse);

        if (paymentResponse.status !== 200) {
          _this.$timeout(function () {
            _this.remain_loading_count--;
            $("#modal-complete-loader-event-confirm .modal-header button.close").trigger("click");
            _this.$progress.complete();
            $("#ngProgress-container").remove();
            _this.displayTextMessage = false;
            _this.$rootScope.loadingWalkThrough = undefined;
            _this.submitPaymentModal(2);
            return;
          });
        }

        let closeRequest = _this.$events.closeEvent(_this.event.id);

        _this.$timeout(function () {
          closeRequest.then(
            function (response) {
              console.log("what is the response");
              console.dir(response);
              if (response.data[0].status === "error") {
                _this.$timeout(function () {
                  _this.remain_loading_count--;
                  _this.$progress.complete();
                  $("#modal-complete-loader-event-confirm .modal-header button.close").trigger("click");
                  $("#modal-complete-loader-event-confirm-modal").modal("toggle");
                  $("#ngProgress-container").remove();
                  _this.displayTextMessage = false;
                  _this.$rootScope.loadingWalkThrough = undefined;
                  //_this.submitPaymentModal(2);
                  _this.setAlert();
                  return;
                });
              } else {
                _this.event.isClosed = true;
                _this.event.isComplete = true;
                _this.$timeout(function () {
                  $("#modal-complete-loader-event-confirm-modal .modal-header button.close").trigger("click");
                  _this.$progress.complete();
                  $("#ngProgress-container").remove();
                });
                _this.showPaymentLoaderButton = true;
                _this.totalChargeForModal = 0;
                try {
                  for (var i = 0; i < paymentResponse.data.length; i++) {
                    if (paymentResponse.data[i].missinPaymentnfo) {
                      _this.arrayOfEmptyAccounts = paymentResponse.data[i].missinPaymentnfo;
                    } else {
                      if (paymentResponse.data[i].status === "error") {
                        _this.errorWithCard.status = true;
                        _this.arrayOfCardErrors.push(paymentResponse.data[i]);
                      } else {
                        _this.arrayOfCardSuccess.push(paymentResponse.data[i]);
                        if (paymentResponse.data[i].charge) {
                          _this.totalChargeForModal = _this.totalChargeForModal + paymentResponse.data[i].charge.amount;
                        }
                      }
                    }
                  }
                } finally {
                  _this.handleErrorsFromPayments();
                  let temp_event = _this.event;
                  _this.$tracking.reportNoShows(_this.jobblers, temp_event);
                  _this.saveShiftDataForLocalytics({
                    event: _this.event,
                    jobblers: _this.jobblers,
                  });
                  _this.$events.trackEventCompletion(_this.jobblers, _this.event, _this.totalChargeForModal, _this.currentUser);
                }
              }
            },
            function (error) {
              alert("Please contact support");
            }
          );
        }, 2000);
      },
      function (response) {
        _this.remain_loading_count--;
        _this.showPaymentLoaderButton = true;
        $("#ngProgress-container").remove();
        _this.$progress.complete();
        _this.errorWithCard.status = true;
        _this.errorWithCard.message = "Error to pay the jobblers.";
      }
    );
  }

  setAlert() {
    var _this = this;
    _this.$timeout(function () {
      alert("The work force was paid, but there seems to be an issue closing the job. Please contact support.");
    }, 300);
  }

  handleErrorsFromPayments() {
    var _this = this;

    /*
	  ////console.log('arrayOfCardErrors');
	  ////console.dir(_this.arrayOfCardErrors);
	  */

    if (_this.arrayOfCardErrors.length === 0) {
      _this.$timeout(function () {
        $("#modal-complete-last-event-confirm-modal").modal();
      }, 300);
    } else {
      _this.error_reason = _this.arrayOfCardErrors[0].message;
      _this.$timeout(function () {
        $("#payment-error-when-closing").modal();
      }, 300);
    }
  }

  sendRatings() {
    var _this = this;

    ////.log('what are the jobblers at this point --');
    ////.dir(_this.jobblers);

    var ratingsArrayForAll = [];

    try {
      _this.jobblers.forEach(function (jobbler) {
        var ratingsObjForDB = {};
        ////.log('each application during payment');
        ////.dir(jobbler);
        if (!jobbler.ratingId) {
          if (jobbler.jobble.noShow) {
            //.log('we have a no show');
            ratingsObjForDB.ratingUser = _this.currentUser.id;
            ratingsObjForDB.ratedUser = jobbler.applicant.id;
            ratingsObjForDB.noteRateGiver = "Did not show up for work.";
            ratingsObjForDB.ratingType = 1;
            ratingsObjForDB.rate = 1;
            ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
            ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
            ratingsArrayForAll.push(ratingsObjForDB);
          } else {
            ////.log('we have a no show');
            if (!jobbler.ratingValue) {
              //.log('no rating value..');
              ratingsObjForDB.ratingUser = _this.currentUser.id;
              ratingsObjForDB.ratedUser = jobbler.applicant.id;
              ratingsObjForDB.noteRateGiver = "No written review by employer.";
              ratingsObjForDB.ratingType = 1;
              ratingsObjForDB.rate = 5;
              ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
              ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
              ratingsArrayForAll.push(ratingsObjForDB);
            }
          }
        }
      });
    } finally {
      var submitRating = {
        method: "POST",
        url: _this.$env.getAPIEndPoint() + "jbl/v1/ratings/upsert?format=json&conf=web",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {ratings: ratingsArrayForAll},
      };
      _this.$http(submitRating).then(function (response) {});
      _this.$timeout(function () {
        _this.$rootScope.loadingWalkThrough = undefined;
        _this.$progress.complete();

        _this.showPaymentLoaderButton = true;
        jQuery("#modal-complete-last-event-confirm").trigger("click");
        $("#ngProgress-container").remove();
        _this.remain_loading_count--;
      }, 500);
    }
  }

  saveShiftDataForLocalytics(params) {
    var _this = this;
    _this.$events.getAcceptedApplicationsTrimmedCompleteTracking(_this.event.subEvents[0].id, 200).then(function (response) {
      var applications = response.data;
      _this.processApplicationsForTracking(applications);
    });
  }

  processApplicationsForTracking(applications) {
    var _this = this;
    applications.forEach(function (application) {
      //console.log('each application');
      //console.dir(application);
      application.jobble.shifts.forEach(function (shift) {
        //console.log("processApplicationsForTrackingprocessApplicationsForTrackingprocessApplicationsForTrackingprocessApplicationsForTrackingprocessApplicationsForTracking");
        _this.$tracking.handleShiftData(application, shift);
      });
    });
  }

  directPayJobbler(shift, application) {
    console.log("directPayJobbler");
    console.dir(shift);
    console.dir(application);
    console.dir(this.currentUser);
    let invoice = this.currentUser.company.payByInvoice;

    this.generateCardsArray();
    this.directPayHours = 0;
    this.directPayMinutes = 0;
    this.directPayAmount = 0;
    this.showCompleteMessage = false;
    this.showMissingInfoMessage = false;
    this.showPaymentError = false;
    this.showPaymentErrorMessage = null;
    this.showLoader = false;
    this.directPayErrorMessage = null;
    this.isDirectPayDisabled = true;
    this.infoForDisplay = application;
    this.shift_for_payment = shift;

    if (invoice !== true) {
      if (this.creditCardsForCompany.values.length === 0) {
        this.$timeout(function () {
          jQuery("#modal-edit-shifts .modal-header button.close").trigger("click");
        });
        this.$timeout(function () {
          jQuery("#direct-pay-on-complete").modal("toggle");
        }, 500);
        this.$timeout(function () {
          jQuery("#modal-add-card").modal();
        }, 900);
        return;
      }
    }

    if (shift) {
      this.shiftForPayment = shift;
      this.directPayHours = shift.shiftDurationInHours;
      this.directPayMinutes = shift.shiftDurationInMinutes;
      this.$timeout(function () {
        jQuery("#modal-edit-shifts .modal-header button.close").trigger("click");
      });
      this.$timeout(function () {
        jQuery("#direct-pay-on-complete-click").trigger("click");
        jQuery("#direct-pay-on-complete .pay-jobbler-on-compelete").show("fast");
      }, 500);
    } else {
      if (this.postType === "regular") {
        this.$timeout(function () {
          jQuery("#modal-edit-shifts .modal-header button.close").trigger("click");
        });
        this.$timeout(function () {
          jQuery("#direct-pay-on-complete-click").trigger("click");
          jQuery("#direct-pay-on-complete .pay-jobbler-on-compelete").show("fast");
        }, 500);
      } else {
        this.$timeout(function () {
          jQuery("#modal-edit-shifts .modal-header button.close").trigger("click");
        });
        this.$timeout(function () {
          jQuery("#direct-pay-on-complete .pay-jobbler-on-compelete").show("fast");
        }, 500);
      }
    }
  }

  payJobblerValidation(isValid) {
    var _this = this;

    let invoice = _this.currentUser.company.payByInvoice;

    console.log("payJobblerValidation");
    console.dir(invoice);
    console.dir(_this.shiftForPayment);

    try {
      _this.$rootScope.defaultCard = _this.creditCardsForCompany.value;
      _this.updateShiftHoursAndBeDone(_this.shift_for_payment, _this.directPayHours, _this.directPayMinutes);
    } finally {
      var paymentTotal = null;

      if (_this.directPayHours || _this.directPayMinutes) {
        paymentTotal = (((_this.directPayHours * 60 + _this.directPayMinutes) * (_this.infoForDisplay.jobble.payPerHour / 100)) / 60).toFixed(2);
        paymentTotal = paymentTotal * 100;
      } else {
        paymentTotal = (_this.directPayAmount * (1 + _this.currentUser.company.defaultPlan.companyFeePct)).toFixed(2);
        paymentTotal = paymentTotal * 100;
      }

      _this.$timeout(function () {
        jQuery("#direct-pay-on-complete .pay-jobbler-on-compelete").hide("slow");
      }, 300);
      _this.$timeout(function () {
        _this.showLoader = true;
        jQuery("#direct-pay-on-complete .image-to-hide").show("slow");
      }, 400);

      var transferArray = null;

      if (_this.shiftForPayment) {
        transferArray = [
          {
            recipient: _this.infoForDisplay.applicant.email,
            amount: paymentTotal,
            note: "Payment",
            shift: _this.shiftForPayment.id,
          },
        ];
      } else {
        transferArray = [
          {
            recipient: _this.infoForDisplay.applicant.email,
            amount: paymentTotal,
            note: "Payment",
            jobble: _this.infoForDisplay.jobble.id,
          },
        ];
      }

      let data = {};
      data.transfers = transferArray;

      if (invoice === true) {
      } else {
        if (_this.creditCardsForCompany.value.is_bank) {
          data.bank = _this.$rootScope.defaultCard.token;
        } else {
          data.card = _this.$rootScope.defaultCard.token;
        }
      }

      var reqPayJobbler = {
        method: "POST",
        url: _this.$env.getAPIEndPoint() + "jbl/v1/stripe/transfer?format=json",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: data,
      };

      _this.$http(reqPayJobbler).then(
        function (response) {
          if (_this.shiftForPayment) {
            _this.handleResponseFromPayment(response, paymentTotal);
          } else {
            _this.handleResponseFromPayment(response, paymentTotal);
          }
        },
        function (response) {
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    }
  }

  updateShiftHoursAndBeDone(shift, hours, minutes) {
    var _this = this;

    ////console.log('updateShiftHoursAndBeDone');
    ////console.dir(shift);
    ////console.dir(hours);
    ////console.dir(minutes);

    let totalMinutes = hours * 60 + minutes;
    shift.actualMinutesWorked = totalMinutes;

    _this.$security.putActualMinutesWorkedForShiftTrimmed(shift.id, totalMinutes).then(
      function (response) {
        ////console.log('putActualMinutesWorkedForShiftTrimmed');
        ////console.dir(response);
        _this.updateJobHoursAndBeDone(totalMinutes);
      },
      function (error) {
        ////console.log('error storing updated shift minutes');
        ////console.dir(error)
      }
    );
  }

  updateJobHoursAndBeDone(minutes) {
    var _this = this;

    ////console.log('updateJobHoursAndBeDone');
    ////console.dir(minutes);
    ////console.dir(_this.infoForDisplay);
    let application = _this.infoForDisplay;
    let jobble_minutes = application.jobbleDurationData.hours * 60 + application.jobbleDurationData.minutes;
    let job = {};
    job.id = application.jobble.id;

    if (application.jobble.actualMinutesWorked && application.jobble.actualMinutesWorked > 0) {
      jobble_minutes = application.jobble.actualMinutesWorked;
    }

    if (jobble_minutes > minutes) {
      job.actualMinutesWorked = jobble_minutes - minutes;
    } else {
      job.actualMinutesWorked = 0;
    }

    if (job.actualMinutesWorked < 0) {
      ////console.log('some how were negative');
      job.actualMinutesWorked = 0;
    }

    job.actualRevenue = (job.actualMinutesWorked * _this.infoForDisplay.jobble.payPerHour) / 60;

    _this.$security.putActualMinutesWorkedTrimmed(job.id, job.actualMinutesWorked).then(
      function (response) {
        ////console.log('putActualMinutesWorkedTrimmed resonpse');
        ////console.dir(response);

        _this.jobblers.some(function (elem) {
          if (elem.jobble.id === job.id) {
            elem.jobble.actualMinutesWorked = job.actualMinutesWorked;
            elem.jobbleDurationData.minutes = job.actualMinutesWorked % 60;
            elem.jobbleDurationData.hours = Math.floor(job.actualMinutesWorked / 60);
            elem.jobble.totalCalculated = job.actualRevenue / 100;
            elem.showActualMinutesWorked = true;
          }
        });
      },
      function (error) {
        ////console.log('error putting the minutes on the job');
        ////console.dir(error);
      }
    );
  }

  handleResponseFromPayment(response, paymentTotal) {
    var _this = this;

    ////console.log('handleResponseFromPayment');
    ////console.dir(response);
    ////console.dir(paymentTotal);

    if (response.data[0].status === "error") {
      _this.$timeout(function () {
        _this.showPaymentError = true;
        _this.showPaymentErrorMessage = response.data[0].message;
        jQuery("#direct-pay-on-complete .image-to-hide").hide("slow");
      }, 1500);

      return;
    }

    if (response.data[0].missinPaymentnfo) {
      var missingInfo = response.data[0].missinPaymentnfo[0];
      ////.log('missing info');
      ////.dir(missingInfo);
      _this.$timeout(function () {
        jQuery("#direct-pay-on-complete .image-to-hide").hide("slow");
        //_this.calculateNumbersForTableAfterUpdate(paymentTotal);
        _this.showMissingInfoMessage = true;
      }, 1000);
    } else {
      _this.$timeout(function () {
        jQuery("#direct-pay-on-complete .image-to-hide").hide("slow");
        _this.calculateNumbersForTableAfterUpdate(paymentTotal);
        _this.showCompleteMessage = true;
      }, 1000);
    }
  }

  calculateNumbersForTableAfterUpdate(totalCharge, application) {
    var _this = this;

    ////console.log('do we have this?');
    ////console.dir(application);

    try {
      for (var i = 0; i < _this.jobblers.length; i++) {
        if (_this.infoForDisplay.applicant.id === _this.jobblers[i].applicant.id) {
          ////console.log('we have a match lets update the shifts pay info');
          ////console.dir(_this.jobblers[i]);
          ////console.dir(_this.shift_for_payment);

          _this.jobblers[i].jobble.numberOfPayment = _this.jobblers[i].jobble.numberOfPayment + 1;
          _this.jobblers[i].jobble.amountPaid = _this.jobblers[i].jobble.amountPaid + totalCharge;
          _this.jobblers[i].jobble.averageAmount = _this.jobblers[i].jobble.amountPaid / _this.jobblers[i].jobble.numberOfPayment;
          _this.jobblers[i].paymentToshiftHasBeenMade = true;
          _this.markJobbleAsReadyForAdditionalPaymentsCancel(_this.jobblers[i]);
          _this.jobblers[i].paymentTotalTransactions = _this.jobblers[i].paymentTotalTransactions + 1;

          for (var x = 0; x < _this.jobblers[i].jobble.shifts.length; x++) {
            ////console.log('each shift?');
            ////console.dir(_this.jobblers[i].jobble.shifts[x]);
            ////console.dir(_this.shift_for_payment);

            if (_this.jobblers[i].jobble.shifts[x].id === _this.shift_for_payment.id) {
              ////console.log('we match shifts');
              ////console.dir(totalCharge);
              ////console.dir(_this.jobblers[i].jobble.shifts[x].paymentStats.number + 1);
              _this.jobblers[i].jobble.shifts[x].paymentStats.number = _this.jobblers[i].jobble.shifts[x].paymentStats.number + 1;
              _this.jobblers[i].jobble.shifts[x].paymentStats.amount = totalCharge;
              break;
            }
          }
        }
      }
    } finally {
      _this.sourcingPostTotals(_this.jobblers);
    }
  }

  payJobblerValidationAmount(isValid) {
    var _this = this;
    ////.log('payJobblerValidationAmount');
    ////.dir(isValid);
  }

  goToHistory() {
    var _this = this;

    _this.$timeout(function () {
      _this.$state.go("jobsdashboard", {});
    }, 300);
  }

  amountChange() {
    var _this = this;

    ////console.log('amount change???');
    ////console.dir(_this.isDirectPayDisabled);

    if ((_this.directPayHours > 0 || _this.directPayMinutes > 0) && (_this.directPayAmount === null || _this.directPayAmount === 0)) {
      if (_this.creditCardsForCompany.value !== "Payment Method") {
        _this.isDirectPayDisabled = false;
        _this.directPayErrorMessage = null;
      }
    } else {
      if ((_this.directPayHours > 0 || _this.directPayMinutes > 0) && _this.directPayAmount > 0) {
        _this.isDirectPayDisabled = true;
        _this.directPayErrorMessage =
          "You have attempted to pay by shift information and also by amount. Please choose between either paying between shift or by amount.";
      } else {
        if (_this.directPayAmount > 0) {
          _this.directPayErrorMessage = null;
          if (_this.creditCardsForCompany.value !== "Payment Method") {
            _this.isDirectPayDisabled = false;
            _this.directPayErrorMessage = null;
          } else {
          }
        } else {
          if (_this.directPayAmount !== 0 && _this.directPayAmount !== null && !angular.isUndefined(_this.directPayAmount)) {
            _this.isDirectPayDisabled = true;
            _this.directPayErrorMessage = "Please enter an amount that is more than $10.00";
          } else {
            _this.directPayAmount = null;
            _this.directPayErrorMessage = null;
          }
        }
      }
    }
  }

  generateCardsArray() {
    var _this = this;
    var credCardArray = [];
    var pay_obj_array = [];

    if (!_this.creditCards) {
      _this.creditCards = [];
    }

    if (_this.creditCards.length === 0 && _this.currentUser.company.payByInvoice !== true) {
      _this.isDirectPayDisabledNew = true;
    } else {
      _this.isDirectPayDisabledNew = false;
    }
    try {
      _this.creditCards.forEach(function (card) {
        let card_obj = {};
        if (card.bankName) {
          card_obj.is_bank = true;
          card_obj.token = card.stripeId;
        } else {
          card_obj.is_bank = false;
          card_obj.token = card.cardToken;
        }
        card_obj.id = card.id;
        card_obj.last4edited = "************-" + card.last4;
        pay_obj_array.push(card_obj);
      });
    } finally {
      if (!_this.$rootScope.defaultCard) {
        _this.$rootScope.defaultCard = {};
        _this.$rootScope.defaultCard = pay_obj_array[0];
      }
      _this.creditCardsForCompany = {
        value: _this.$rootScope.defaultCard,
        values: pay_obj_array,
      };
    }
  }

  goToTransHist() {
    var _this = this;

    _this.$timeout(function () {
      jQuery("#direct-pay-on-complete .modal-header button.close").trigger("click");
    });

    _this.$timeout(function () {
      _this.$state.go("transactionhistory");
    }, 300);
  }

  sourcingPostTotals(applications) {
    var _this = this;

    _this.totalsForSourcingPostNumberOfPayment = 0;
    _this.totalsForSourcingPostAmountPaid = 0;
    _this.totalsForSourcingPostAverageAmount = 0;

    try {
      applications.forEach(function (application) {
        _this.totalsForSourcingPostNumberOfPayment = _this.totalsForSourcingPostNumberOfPayment + application.jobble.numberOfPayment;
        _this.totalsForSourcingPostAmountPaid = _this.totalsForSourcingPostAmountPaid + application.jobble.amountPaid;
      });
    } finally {
      if (_this.totalsForSourcingPostAmountPaid === 0 && _this.totalsForSourcingPostNumberOfPayment === 0) {
        _this.totalsForSourcingPostAverageAmount = 0;
      } else {
        _this.totalsForSourcingPostAverageAmount = _this.totalsForSourcingPostAmountPaid / _this.totalsForSourcingPostNumberOfPayment;
      }
    }
  }

  enterPressedHours(shift) {
    var _this = this;

    shift.isBeingEdited = undefined;
    shift.isBeingEditedMinutes = undefined;

    _this.updateActualMinutesWorked("hours", _this.hoursValueForEditedShift, shift.shiftDurationInHours, shift);
  }

  enterPressedMin(shift) {
    var _this = this;

    shift.isBeingEdited = undefined;
    shift.isBeingEditedMinutes = undefined;
    ////////console.log('enterPressedMin');
    ////////console.dir(_this.minValueForEditedShift);
    if (angular.isUndefined(_this.minValueForEditedShift)) {
      alert("Please enter minutes in intervals of 15");
      return;
    }

    _this.remain_loading_count++;

    _this.updateActualMinutesWorked("mins", _this.minValueForEditedShift, shift.shiftDurationInMinutes, shift);
  }

  inlineEditShift(type, shift, shifts) {
    var _this = this;

    if (!shift.noShow) {
      if (shift.paymentStats.number === 0) {
        shifts.forEach(function (sh) {
          if (sh.id !== shift.id) {
            sh.isBeingEditedMinutes = undefined;
            sh.isBeingEdited = undefined;
            shift.autofocusminutes = undefined;
            shift.autofocushours = undefined;
            shift.focusClass = undefined;
          }
        });

        if (type === "hours") {
          shift.isBeingEdited = true;
          shift.isBeingEditedMinutes = undefined;
          _this.hoursValueForEditedShift = shift.shiftDurationInHours;
          shift.focusClass = "has-focus";
          _this.$timeout(function () {
            jQuery("#modal-edit-shifts .modal-body .has-focus").focus();
          });
        } else {
          shift.isBeingEdited = undefined;
          shift.isBeingEditedMinutes = true;
          _this.minValueForEditedShift = shift.shiftDurationInMinutes;
          shift.focusClass = "has-focus";
          _this.$timeout(function () {
            jQuery("#modal-edit-shifts .modal-body .has-focus").focus();
          });
        }
      }
    }
  }

  inlineEditShiftJob(type, job) {
    var _this = this;

    if (type === "minutes") {
      job.isBeingEditedMinutes = true;
      job.isBeingEdited = undefined;
      job.focusClass = "has-focus-job";

      _this.$timeout(function () {
        jQuery("#modal-edit-shifts .modal-body .has-focus-job").focus();
      });
    } else {
      job.isBeingEditedMinutes = undefined;
      job.isBeingEdited = true;
      job.focusClass = "has-focus-job";

      _this.$timeout(function () {
        jQuery("#modal-edit-shifts .modal-body .has-focus-job").focus();
      });
    }
  }

  jobFocus(job) {
    var _this = this;
  }

  hourChange() {
    var _this = this;
  }

  minuteChange() {
    var _this = this;
  }

  jobBlur(job, type) {
    var _this = this;

    if (type === "mins") {
      job.isBeingEditedMinutes = undefined;
      _this.storeMinutesForDBCall(job);
      job.durationInMinutesForJob = _this.minutePreview;
    } else {
      job.isBeingEdited = undefined;
      _this.storeHoursForDBCall(job);
      job.durationInHoursForJob = _this.hourPreview;
    }
  }

  shiftFocus(shift, type) {
    var _this = this;
  }

  shiftBlur(shift, type) {
    var _this = this;

    if (type === "mins") {
      ////////console.log('in mins');

      shift.isBeingEditedMinutes = undefined;
      _this.updateActualMinutesWorked(type, _this.minValueForEditedShift, shift.durationInMinutes, shift);
      shift.durationInMinutes = _this.minValueForEditedShift;
    } else {
      shift.isBeingEdited = undefined;
      _this.updateActualMinutesWorked(type, _this.hoursValueForEditedShift, shift.shiftDurationInHours, shift);
      shift.shiftDurationInHours = _this.hoursValueForEditedShift;
    }
  }

  toggleKey() {
    var _this = this;
    if (_this.userHasQuestions) {
      _this.userHasQuestions = false;
      _this.$timeout(function () {
        jQuery("#modal-jobble-shift .modal-body .jobble-shift .key-wrapper").hide("slow");
      });
    } else {
      _this.userHasQuestions = true;
      _this.$timeout(function () {
        jQuery("#modal-jobble-shift .modal-body .jobble-shift .key-wrapper").show("slow");
      });
    }
  }

  markJobblerAsNoShowForJob() {
    //////////console.log('how many times am i getting called');
    //////////console.log('markJobblerAsNoShowForJob');

    var _this = this;

    _this.remain_loading_count = 1;

    _this.$timeout(function () {
      ////////console.log('right before setting loader');
      _this.$rootScope.$emit("SetLoaderDialog", {type: 1, total: 1});
    });

    _this.$security.markJobblerAsNoShowTrimmed(_this.infoForDisplay).then(
      function (response) {
        _this.remain_loading_count--;

        _this.jobblers.some(function (elem) {
          if (elem.jobble.id === response.data.id) {
            elem.noShowClass = "no-show-jobbler";
            elem.jobble.paidOutClass = "jobbler-is-no-show";
            elem.jobble.hoursForShow = 0;
            elem.jobble.minutesForShow = 0;
            elem.ratingValue = 1;
            _this.minutePreview = 0;
            _this.hourPreview = 0;
            elem.jobble.noShow = true;

            ////////console.log('what is the elem after we match?');
            ////////console.dir(elem);
          }
        });
      },
      function (data) {
        _this.remain_loading_count--;

        alert("There appears to be an error marking this jobbler as a no show. Please refresh your page to view updated information.");
      }
    );
  }

  markJobblerAsNoShowForJobCancel() {
    var _this = this;

    var momentETT = moment(_this.infoForDisplay.jobble.endTime);
    var momentSTT = moment(_this.infoForDisplay.jobble.startTime);

    _this.remain_loading_count++;
    _this.infoForDisplay.jobble.actualMinutesWorked = _this.infoForDisplay.jobble.jobbleDurationInMinutes;
    _this.infoForDisplay.jobble.actualRevenue = (_this.infoForDisplay.jobble.actualMinutesWorked * _this.infoForDisplay.jobble.payPerHour) / 60;
    _this.$security
      .markJobblerAsNoShowCancel(_this.infoForDisplay)

      .then(
        function (response) {
          _this.jobblers.some(function (elem) {
            if (elem.jobble.id === response.data.id) {
              elem.jobble.paidOutClass = "";
              elem.jobble.noShow = null;
              elem.noShowClass = null;
              elem.ratingValue = 5;
              var momentET = moment(response.data.endTime);
              var momentST = moment(response.data.startTime);
              elem.jobble.actualMinutesWorked = response.data.jobbleDurationInMinutes;
              elem.jobble.actualRevenue = (elem.jobble.actualMinutesWorked * elem.jobble.payPerHour) / 60;
              //elem.jobble.no_show_cancelled = true;
              var timeObj = _this.figureOutTheTime(response.data.jobbleDurationInMinutes);
              _this.minutePreview = timeObj.minutes;
              _this.hourPreview = timeObj.hours;
            }
            _this.$timeout(function () {
              _this.remain_loading_count = 0;
            }, 300);
          });
        },
        function (data) {
          _this.remain_loading_count--;

          alert("There appears to be an error marking this jobbler as a no show. Please refresh your page to view updated information.");
        }
      );
  }

  markJobblerShowShowForShift(shift, value, aligningJobbleAndShift, fromMainPage, jobble) {
    var _this = this;

    _this.remain_loading_count++;

    console.log("markJobblerShowShowForShift");
    console.dir(_this.infoForDisplay);
    console.dir(shift);
    console.dir(value);
    console.log("aligningJobbleAndShift");
    console.dir(aligningJobbleAndShift);
    console.dir(jobble);
    console.log("from Main page");
    console.dir(fromMainPage);

    if (_this.infoForDisplay.jobble.shifts.length === 1) {
      aligningJobbleAndShift = true;
    } else {
      aligningJobbleAndShift = false;
    }

    if (value) {
      shift.noShow = true;
      shift.paidOutClass = "jobbler-is-no-show";
      shift.shiftDurationInHours = 0;
      shift.shiftDurationInMinutes = 0;

      if (shift.actualMinutesWorked && shift.actualMinutesWorked !== 0) {
        //_this.infoForDisplay.jobble.jobbleDurationInMinutes = _this.infoForDisplay.jobble.jobbleDurationInMinutes - shift.actualMinutesWorked;
        _this.infoForDisplay.jobble.actualMinutesWorked = _this.infoForDisplay.jobble.actualMinutesWorked - shift.actualMinutesWorked;
        _this.hourPreview = Math.floor(_this.infoForDisplay.jobble.actualMinutesWorked / 60);
        _this.minutePreview = _this.infoForDisplay.jobble.actualMinutesWorked % 60;

        if (!aligningJobbleAndShift) {
          ////console.log('aligningJobbleAndShift should NOT BE HERE');
          //_this.storeMinutesForDBCall(_this.infoForDisplay.jobble);
        }

        _this.$timeout(function () {
          //_this.storeMinutesForDBCallShift(shift, 0);
        }, 300);
      } else {
        let momentET = moment(shift.timeInterval.endTime);
        let momentST = moment(shift.timeInterval.startTime);
        let totalMinutes = momentET.diff(momentST, "minutes");
        let hoursRounded = Math.floor(totalMinutes / 60);
        let minutesRounded = totalMinutes % 60;
        _this.infoForDisplay.jobble.jobbleDurationInMinutes = _this.infoForDisplay.jobble.jobbleDurationInMinutes - totalMinutes;
        _this.infoForDisplay.jobble.actualMinutesWorked = _this.infoForDisplay.jobble.jobbleDurationInMinutes;
        _this.hourPreview = Math.floor(_this.infoForDisplay.jobble.actualMinutesWorked / 60);
        _this.minutePreview = _this.infoForDisplay.jobble.actualMinutesWorked % 60;

        if (!aligningJobbleAndShift) {
          ////console.log('aligningJobbleAndShift should NOT BE HERE 2');
          //_this.storeMinutesForDBCall(_this.infoForDisplay.jobble);
        }

        _this.$timeout(function () {
          //_this.storeMinutesForDBCallShift(shift, 0);
        }, 1000);
      }
    } else {
      //k0 here
      shift.noShow = null;
      let momentET = moment(shift.timeInterval.endTime);
      let momentST = moment(shift.timeInterval.startTime);
      let totalMinutes = (shift.shiftDurationInMinutes = momentET.diff(momentST, "minutes"));
      let hoursRounded = Math.floor(totalMinutes / 60);
      //console.log("why are we adding these");
      //console.dir(_this.infoForDisplay.jobble.jobbleDurationInMinutes);
      //console.dir(totalMinutes);
      if (_this.infoForDisplay.jobble.jobbleDurationInMinutes === 0) {
        _this.infoForDisplay.jobble.jobbleDurationInMinutes = _this.infoForDisplay.jobble.jobbleDurationInMinutes + totalMinutes;
      }
      _this.infoForDisplay.jobble.actualMinutesWorked = _this.infoForDisplay.jobble.actualMinutesWorked + totalMinutes;
      _this.hourPreview = _this.hourPreview + shift.shiftDurationInHours;
      _this.minutePreview = _this.minutePreview % 60;
      let fromFunc = true;
      if (!fromMainPage) {
        //_this.storeMinutesForDBCall(_this.infoForDisplay.jobble);
      }
      _this.$timeout(function () {
        //_this.storeMinutesForDBCallShift(shift, totalMinutes, fromFunc);
      }, 300);
      if (shift.amountPaid) {
        shift.paidOutClass = "success-payment-shifts";
      } else {
        shift.paidOutClass = "undefined";
      }
    }

    _this.$timeout(function () {
      var putNowShow = {
        method: "PUT",
        url: _this.$env.getAPIEndPoint() + "jbl/v1/shifts/" + shift.id + "?format=json&conf=web&fields=id",

        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },

        data: {
          noShow: value,
          actualMinutesWorked: 0,
        },
      };

      _this.$http(putNowShow).then(
        function (response) {
          if (response.status === "error") {
            alert("Error saving information");
          } else {
            if (_this.infoForDisplay.jobble.shifts.length === 1) {
              _this.dataModelForNoShow = _this.infoForDisplay;
              if (value && !aligningJobbleAndShift) {
                _this.markJobblerAsANoShowFromMainPageCancel();
              } else {
                if (!fromMainPage) {
                  _this.markJobblerAsANoShowFromMainPage();
                  _this.infoForDisplay.outstandingTotalsData.hours = 0;
                  _this.infoForDisplay.outstandingTotalsData.minutes = 0;
                  _this.infoForDisplay.outstandingTotalsData.monies = 0;
                }
              }
            }
          }

          _this.$timeout(function () {
            _this.remain_loading_count = 0;
          }, 500);
        },
        function (data) {
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    }, 1300);
  }

  addUpShiftHours() {
    var _this = this;
    var minuteHolder = 0;

    try {
      _this.infoForDisplay.jobble.shifts.forEach(function (s) {
        ////.log('if they are no show?');
        ////.dir(s);
        if (!s.noShow) {
          if (s.actualMinutesWorked) {
            minuteHolder = minuteHolder + s.actualMinutesWorked;
            ////.log('what is the minute holder');
            ////.dir(minuteHolder);
            s.shiftDurationInHours = Math.floor(s.actualMinutesWorked / 60);
            s.shiftDurationInMinutes = s.actualMinutesWorked % 60;
          } else {
            ////.log('what is s');
            ////.dir(s);
            var momentET = moment(s.timeInterval.endTime);
            var momentST = moment(s.timeInterval.startTime);
            var totalMinutes = momentET.diff(momentST, "minutes");
            ////.log('total minutes?');
            ////.dir(totalMinutes);
            minuteHolder = minuteHolder + totalMinutes;
          }
        }
      });
    } finally {
      //var hoursRounded = Math.floor(minuteHolder / 60);
      //_this.hourPreview = hoursRounded;
      //_this.minutePreview = minuteHolder % 60;
    }
  }

  toggleShiftTable() {
    var _this = this;

    _this.addUpShiftHours();

    if (_this.userWantsShifts) {
      _this.userWantsShifts = false;
      _this.editByShift = false;
      _this.$timeout(function () {
        jQuery("#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows").hide("slow");
      });
    } else {
      _this.userWantsShifts = true;
      _this.editByShift = true;
      _this.$timeout(function () {
        jQuery("#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows").show("slow");
      });
    }
  }

  storeMinutesForDBCall(job) {
    var _this = this;

    job.isBeingEditedMinutes = undefined;

    if (_this.minutePreview > 59 || angular.isUndefined(_this.minutePreview)) {
      alert("Please enter minutes in intervals of 15");
      //_this.minutePreview = 0;
      return;
    }

    job.actualMinutesWorked = _this.minutePreview + _this.hourPreview * 60;
    job.actualRevenue = (job.actualMinutesWorked * job.payPerHour) / 60;

    _this.showLoaderFunc(2);

    ////console.log('right before putting the actual minutes worked trimmed');
    ////console.dir(job);

    _this.$security.putActualMinutesWorkedTrimmed(job.id, job.actualMinutesWorked, job.actualRevenue).then(function (response) {
      try {
        _this.jobblers.some(function (elem) {
          if (elem.jobble.id === job.id) {
            ////console.log('do we ever get a match?');
            ////console.dir(response.data);
            ////console.dir(response.data.actualMinutesWorked);
            ////console.dir(response.data.actualMinutesWorked % 60);
            ////console.dir(Math.floor(response.data.actualMinutesWorked / 60));

            elem.jobble.actualMinutesWorked = response.data.actualMinutesWorked;
            elem.jobbleDurationData.minutes = response.data.actualMinutesWorked % 60;
            elem.jobbleDurationData.hours = Math.floor(response.data.actualMinutesWorked / 60);

            if (_this.infoForDisplay.outstandingTotalsData) {
              _this.infoForDisplay.outstandingTotalsData.hours = elem.jobbleDurationData.hours;
              _this.infoForDisplay.outstandingTotalsData.minutes = elem.jobbleDurationData.minutes;
            }

            elem.jobble.totalCalculated = job.actualRevenue / 100;
            elem.showActualMinutesWorked = true;
          }
        });
      } finally {
        _this.showLoaderFunc(2);
      }
    });
  }

  storeHoursForDBCall(job, fromMainPage) {
    var _this = this;

    _this.showLoaderFunc(1);

    let jobArg = {};

    if (fromMainPage) {
      job.jobble.durationInHoursForJob = job.jobbleDurationData.hours;
      job.jobble.actualMinutesWorked = job.jobbleDurationData.minutes + job.jobbleDurationData.hours * 60;
      job.actualMinutesWorked = job.jobbleDurationData.minutes + job.jobbleDurationData.hours * 60;
      job.actualRevenue = (job.jobble.actualMinutesWorked * job.jobble.payPerHour) / 60;
      job.jobble.actualRevenue = (job.jobble.actualMinutesWorked * job.jobble.payPerHour) / 60;
      job.jobble.totalCalculated = (job.jobble.actualMinutesWorked * job.jobble.payPerHour) / 60 / 100;
      jobArg.id = job.jobble.id;
      jobArg.actualMinutesWorked = job.jobble.actualMinutesWorked;
    } else {
      job.isBeingEdited = undefined;
      job.durationInHoursForJob = _this.hourPreview;
      job.actualMinutesWorked = _this.minutePreview + _this.hourPreview * 60;
      job.actualRevenue = (job.actualMinutesWorked * job.payPerHour) / 60;
      jobArg.id = job.id;
      jobArg.actualMinutesWorked = job.actualMinutesWorked;
    }

    _this.$security.putActualMinutesWorkedTrimmed(jobArg.id, jobArg.actualMinutesWorked).then(
      function (response) {
        ////console.log('what is the job');
        ////console.dir(job);
        ////console.dir(fromMainPage);

        if (!fromMainPage) {
          ////console.log('so we come here')

          _this.jobblers.some(function (elem) {
            ////////console.dir('what is this number');
            ////////console.dir(job.actualRevenue);
            if (elem.jobble.id === job.id) {
              ////console.log('we have a match here');
              ////console.dir(elem);

              elem.jobbleDurationData.minutes = response.data.actualMinutesWorked % 60;
              elem.jobbleDurationData.hours = Math.floor(response.data.actualMinutesWorked / 60);
              elem.jobble.actualMinutesWorked = response.data.actualMinutesWorked;
              elem.jobble.totalCalculated = job.actualRevenue / 100;
              elem.showActualMinutesWorked = true;

              _this.calcOutstandingHours(elem);
              _this.showLoaderFunc(1);
            }
          });
        } else {
          if (job.shift_count === 1) {
            ////console.log('whats the shift count?');
            _this.updateSingleShift(job);
          }
        }
      },
      function (error) {
        //////console.log('handle error on storing minutes from jobble');
        //////console.dir(error);
      }
    );
  }

  storeMinutesForDBCallShift(shift, newMinutes, fromFunc) {
    var _this = this;

    ////console.log('-----------------storeMinutesForDBCallShift----------------------');
    ////console.dir(shift);
    ////console.dir(newMinutes);
    ////console.dir(fromFunc);

    if (!fromFunc) {
      ////////console.log('from func');
      if (newMinutes > 59 || angular.isUndefined(newMinutes)) {
        //////////console.log('in if');
        alert("Please enter minutes in intervals of 15");
        //shift.durationInMinutes = 0;
        return;
      }
    }

    let totalMinutes = shift.shiftDurationInHours * 60 + newMinutes;

    shift.actualMinutesWorked = totalMinutes;

    _this.$security.putActualMinutesWorkedForShiftTrimmed(shift.id, totalMinutes).then(function (response) {
      _this.infoForDisplay.jobble.shifts.some(function (elem) {
        if (elem.id === shift.id) {
          ////console.log('putActualMinutesWorkedForShiftTrimmed we found a match');

          elem.actualMinutesWorked = response.data.actualMinutesWorked;
          elem.shiftDurationInMinutes = response.data.actualMinutesWorked % 60;
          elem.shiftDurationInHours = Math.floor(response.data.actualMinutesWorked / 60);

          _this.addUpMinutesAndHours(_this.infoForDisplay);
        }
      });
    });
  }

  addUpMinutesAndHours(info) {
    var _this = this;

    info.jobble.actualMinutesWorked = 0;

    ////console.log('do we do this?');

    try {
      info.jobble.shifts.some(function (elem) {
        if (elem.actualMinutesWorked === null) {
          let hoursToMin = elem.shiftDurationInHours * 60;
          let mins = elem.shiftDurationInMinutes;
          let totalMins = hoursToMin + mins;

          info.jobble.actualMinutesWorked = info.jobble.actualMinutesWorked + totalMins;
        } else {
          info.jobble.actualMinutesWorked = info.jobble.actualMinutesWorked + elem.actualMinutesWorked;
        }
      });
    } finally {
      ////console.log('whats going here...');
      ////console.dir(_this.infoForDisplay.jobble.actualMinutesWorked);
      ////console.dir(_this.infoForDisplay.jobble.actualMinutesWorked / 60);

      _this.hourPreview = Math.floor(_this.infoForDisplay.jobble.actualMinutesWorked / 60);
      _this.minutePreview = _this.infoForDisplay.jobble.actualMinutesWorked % 60;

      _this.$timeout(function () {
        _this.remain_loading_count = 0;
      }, 300);
    }
  }

  updateSingleShift(application) {
    var _this = this;

    ////console.log('updating single shift');
    ////console.dir(application);

    let newActualMinutesWorked = application.jobble.actualMinutesWorked;

    _this.storeHoursForDBCallShift(application.jobble.shifts[0], newActualMinutesWorked, true);

    //_this.storeHoursForDBCallShift()
    //storeHoursForDBCallShift(shift, newHours, updatingFromMainPage)
  }

  storeHoursForDBCallShift(shift, newHours, updatingFromMainPage) {
    var _this = this;

    let totalMinutes = 0;

    if (updatingFromMainPage) {
      totalMinutes = newHours;
    } else {
      totalMinutes = newHours * 60 + shift.shiftDurationInMinutes;
    }

    shift.actualMinutesWorked = totalMinutes;

    _this.$security.putActualMinutesWorkedForShiftTrimmed(shift.id, totalMinutes).then(function (response) {
      if (!updatingFromMainPage) {
        _this.infoForDisplay.jobble.shifts.some(function (elem) {
          if (elem.id === shift.id) {
            elem.actualMinutesWorked = response.data.actualMinutesWorked;
            elem.shiftDurationInHours = Math.floor(response.data.actualMinutesWorked / 60);
            elem.shiftDurationInMinutes = response.data.actualMinutesWorked % 60;

            _this.calculateTotalsForDisplay();
            _this.remain_loading_count = 0;
          }
        });
      }
    });
  }

  updateActualMinutesWorked(type, newVal, oldVal, shift) {
    var _this = this;

    var total = 0;

    _this.remain_loading_count = 1;

    if (type === "hours") {
      try {
        _this.infoForDisplay.jobble.shifts.forEach(function (s) {
          var hoursToMin = null;

          if (s.id === shift.id) {
            hoursToMin = newVal * 60;
          } else {
            hoursToMin = s.shiftDurationInHours * 60;
          }

          var min = s.shiftDurationInMinutes;
          var totalMinutes = hoursToMin + min;

          total = total + totalMinutes;
        });
      } finally {
        _this.hourPreview = Math.floor(total / 60);
        _this.minutePreview = total % 60;

        _this.storeHoursForDBCall(_this.infoForDisplay.jobble);

        _this.storeHoursForDBCallShift(shift, newVal);

        /*
				_this.$timeout(function(){
					_this.remain_loading_count--;
				},100)
				*/
      }
    }

    if (type === "mins") {
      try {
        _this.infoForDisplay.jobble.shifts.forEach(function (s) {
          var min = null;

          if (s.id === shift.id) {
            min = newVal;
          } else {
            min = s.shiftDurationInMinutes;
          }

          var hoursToMin = s.shiftDurationInHours * 60;
          var totalMinutes = hoursToMin + min;

          total = total + totalMinutes;
        });
      } finally {
        ////////console.log('total minutes');
        ////////console.dir(total);

        _this.hourPreview = Math.floor(total / 60);
        _this.minutePreview = total % 60;
        _this.storeMinutesForDBCall(_this.infoForDisplay.jobble);
        _this.storeMinutesForDBCallShift(shift, newVal);

        /*
				_this.$timeout(function(){
					_this.remain_loading_count=1;
				},500)
				*/
      }
    }

    _this.$timeout(function () {
      jQuery("#modal-jobble-shift table tbody .top-level").addClass("flash-success");
    });

    _this.$timeout(function () {
      jQuery("#modal-jobble-shift table tbody .top-level").removeClass("flash-success");
    }, 1000);
  }

  organizePaymentInfo() {
    var _this = this;

    if (_this.paymentInfos) {
      try {
        ////////console.log('what is the payment info at this point');
        ////////console.dir(_this.paymentInfos);

        _this.paymentInfos.forEach(function (paymentInfo) {
          if (paymentInfo.bankName) {
            _this.banksArray.push(paymentInfo);
          } else {
            _this.cardsArray.push(paymentInfo);
          }
        });
      } finally {
        _this.cardsArray.forEach(function (paymentInfo) {
          paymentInfo.cardExpirationDate =
            moment().month(parseInt(paymentInfo.cardExpirationMonth)).format("MM") + "/" + paymentInfo.cardExpirationYear;
        });
      }
    }
  }

  toggleCheckBox() {
    var _this = this;
    ////.log('toggleCheckBox');
    ////.dir(_this.editByShift);
    /*
		if (_this.editByShift) {
			_this.userWantsShifts = false;
			_this.$timeout(function(){
				jQuery('#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows').hide('slow');
			})
		} else {
			_this.userWantsShifts = true;
			_this.$timeout(function(){
				jQuery('#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows').show('slow');
			})
		}
		*/
    /*
		if (_this.userWantsShifts) {
			_this.userWantsShifts = false;
			 _this.$timeout(function(){
				  jQuery('#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows').hide('slow');
			  })
		} else {
			_this.userWantsShifts = true;
			_this.$timeout(function(){
				jQuery('#modal-jobble-shift .modal-body .jobble-shift .shift-table-rows').show('slow');
			})
		}
		 */
  }

  totalAmountToBePaidOut() {
    //////console.log('totalAmountToBePaidOut');
    ////console.log("totalAmountToBePaidOuttotalAmountToBePaidOuttotalAmountToBePaidOuttotalAmountToBePaidOut");
    var _this = this;
    var total = 0;
    var totalMinutes = 0;
    try {
      _this.jobblers.forEach(function (application) {
        ////console.dir(application);
        ////console.dir(application.paymentToshiftHasBeenMade);
        ////console.dir(application.isCheckedForAction);
        if (!application.paymentToshiftHasBeenMade && application.isCheckedForAction) {
          ////console.log("checkking no show");
          if (!application.jobble.noShow) {
            ////console.log("checking strike out class");
            if (!application.strikeOutClass) {
              ////console.log("one more check...");
              if (_this.delivery) {
                ////console.log("whats the application in the delivery");
                ////console.dir(application);
                total = application.jobble.payPerHour;
              } else {
                if (application.jobble.actualRevenue || application.jobble.actualRevenue === 0) {
                  //console.log("in the first if........");
                  //console.dir(application);
                  totalMinutes = totalMinutes + application.jobble.actualMinutesWorked;
                  total = total + application.jobble.actualRevenue;
                } else {
                  //console.log("in the else....");
                  //console.dir(application);
                  total = total + application.jobble.costOfJobble;
                  totalMinutes = totalMinutes + application.jobble.jobbleDurationInMinutes;
                }
              }
            }
          }
        }
      });
    } finally {
      _this.totalMinutesWorkedForEntireJob = totalMinutes;
      _this.totalHoursWorkedForEvent();
      _this.totalMinutesWorkedForEvent();
      _this.companyFeePct = (total / 100) * _this.currentUser.company.defaultPlan.companyFeePct.toFixed(2);
      _this.totalFromJobblers = (total / 100).toFixed(2);
      _this.totalsCombined = total / 100 + _this.companyFeePct;
      _this.totalsCombinedNew = numeral(_this.totalsCombined).format("$0,0.00");
      let final_num = numeral(total / 100).format("$0,0.00");
      return final_num;
    }
  }

  removeFromPayment(application) {
    var _this = this;

    _this.$timeout(function () {
      application.strikeOutClass = "strike-out-jobbler";
    });

    _this.totalAmountToBePaidOut();
  }

  addTooPayment(application) {
    var _this = this;

    _this.$timeout(function () {
      application.strikeOutClass = undefined;
    });

    _this.totalAmountToBePaidOut();
  }

  dollarFocus() {
    var _this = this;
    //.log('dollar focus');
    //.dir(_this.directPayAmount);
    if (_this.directPayAmount === 0) {
      _this.directPayAmount = null;
    }
  }

  totalHours() {
    var _this = this;

    var total = 0;

    try {
      _this.infoForDisplay.jobble.shifts.forEach(function (shift) {
        if (shift.actualMinutesWorked !== null) {
          ////.log('we have been edited');
          ////.dir(jobble.actualMinutesWorked);
          ////.dir(Math.floor(jobble.actualMinutesWorked / 60));

          total = total + shift.actualMinutesWorked;
          //var min = jobble.actualMinutesWorked % 60;
        } else {
          ////.log('we have NOT been edited');
          var diffinmin = moment(shift.timeInterval.endTime).diff(moment(shift.timeInterval.startTime), "minutes");
          ////.dir(diffinmin);
          total = total + diffinmin;

          //var min = diffinmin & 60;
        }
      });
    } finally {
      ////.log('do we make it to finally 1');
      ////.dir(total);
      var hrs = Math.floor(total / 60);
      ////.dir(hrs);

      return hrs;
    }
  }

  totalMinutes() {
    var _this = this;

    var total = 0;

    try {
      _this.infoForDisplay.jobble.shifts.forEach(function (shift) {
        ////.log('shift');
        ////.dir(shift);

        if (shift.actualMinutesWorked !== null) {
          ////.log('we have been edited');
          ////.dir(jobble.actualMinutesWorked);
          ////.dir(Math.floor(jobble.actualMinutesWorked / 60));

          total = total + shift.actualMinutesWorked;
          //var min = jobble.actualMinutesWorked % 60;
        } else {
          ////.log('we have NOT been edited');
          var diffinmin = moment(shift.timeInterval.endTime).diff(moment(shift.timeInterval.startTime), "minutes");
          //.dir(diffinmin);
          total = total + diffinmin;

          //var min = diffinmin & 60;
        }
      });
    } finally {
      ////.log('do we make it to finally 2');

      var hourstotal = Math.floor(total / 60);

      var minforsub = hourstotal * 60;
      var mins = total - minforsub;
      ////.dir(hourstotal);
      ////.dir(minforsub);
      ////.dir(total);
      ////.dir(mins);
      return mins;
    }
  }

  showLoaderFunc(type) {
    var _this = this;

    if (type === 1) {
      //////////console.log('total hour loader');
      //////////console.dir(_this.totalHourLoader);
      if (_this.totalHourLoader) {
        //////////console.log('total hour loader 1');
        _this.totalHourLoader = false;
      } else {
        //////////console.log('total hour loader 3');
        _this.totalHourLoader = true;
      }
    }

    if (type === 2) {
      //////////console.log('total min loader');
      //////////console.dir(_this.totalMinLoader);

      if (_this.totalMinLoader) {
        //////////console.log('total min loader1');
        _this.totalMinLoader = false;
      } else {
        //////////console.log('total min loader2');
        _this.totalMinLoader = true;
      }
    }
  }

  showLeadingZero(n) {
    return n < 10 ? "0" + n : n;
  }

  formatCheckInAddress(address, time) {
    if ((address === null || !address) && (time === null || !time)) {
      return "User did not check in";
    } else {
      if ((address === null || !address) && (time !== null || time)) {
        return "The user checked in at an address that was not recognized";
      } else {
        return address;
      }
    }
  }

  formatCheckOutAddress(address, time) {
    if ((address === null || !address) && (time === null || !time)) {
      return "User did not check out";
    } else {
      if ((address === null || !address) && (time !== null || time)) {
        return "The user checked in at an address that was not recognized";
      } else {
        return address;
      }
    }
  }

  formatCheckInTime(input) {
    if (input === null || !input) {
      return "--";
    } else {
      return input;
    }
  }

  formatCheckOutTime(input) {
    if (input === null || !input) {
      return "--";
    } else {
      return input;
    }
  }

  differenceInHours(start, end) {
    return this.$common.differenceInHours(start, end);
  }

  differenceInMinutes(start, end) {
    return this.$common.differenceInMinutes(start, end);
  }

  calcTimeWorked(application) {
    var _this = this;
    if (application.jobble.actualMinutesWorked || application.jobble.actualMinutesWorked === 0) {
      _this.setMinutesWorked(application);
      _this.totalMinutesWorkedForEntireJob = _this.totalMinutesWorkedForEntireJob + application.jobble.actualMinutesWorked;
    } else {
      _this.setJobbleDuration(application);
      _this.totalMinutesWorkedForEntireJob = _this.totalMinutesWorkedForEntireJob + application.jobble.jobbleDurationInMinutes;
    }
    _this.calculateActualData(application);
  }

  calculateActualData(application) {
    var _this = this;

    application.jobbleDurationData = {};

    if (application.paymentToshiftHasBeenMade) {
      application.jobble.actualMinutesWorked = 0;
      application.jobbleDurationData.hours = 0;
      application.jobbleDurationData.minutes = 0;
      application.jobble.totalCalculated = 0;
    } else if (application.jobble.noShow) {
      application.jobbleDurationData.hours = 0;
      application.jobbleDurationData.minutes = 0;
      application.jobble.totalCalculated = 0;
    } else if (application.jobble.actualMinutesWorked) {
      let div = application.jobble.actualMinutesWorked / 60;
      application.jobbleDurationData.hours = Math.floor(div);
      application.jobbleDurationData.minutes = application.jobble.actualMinutesWorked % 60;
      _this.calcData = _this.calcData + application.jobble.actualMinutesWorked;
    } else {
      ////console.log('***dimitry here');
      ////console.dir(application.jobble.jobbleDurationInMinutes);
      let div = application.jobble.jobbleDurationInMinutes / 60;
      application.jobbleDurationData.hours = Math.floor(div);
      application.jobbleDurationData.minutes = application.jobble.jobbleDurationInMinutes % 60;
      _this.calcData = _this.calcData + application.jobble.jobbleDurationInMinutes;
    }

    ////console.log('what is calc data');
    ////console.dir(_this.calcData);
  }

  setMinutesWorked(application) {
    var _this = this;

    let div = null;

    if (application.jobble.actualMinutesWorked) {
      div = application.jobble.actualMinutesWorked / 60;
      application.jobble.hoursForShow = Math.floor(div);
      application.jobble.minutesForShow = application.jobble.actualMinutesWorked % 60;
    } else {
      div = application.jobble.jobbleDurationInMinutes / 60;
      application.jobble.hoursForShow = Math.floor(div);
      application.jobble.minutesForShow = application.jobble.jobbleDurationInMinutes % 60;
    }

    _this.totalForIndividual(application, 1);
  }

  setJobbleDuration(application) {
    var _this = this;
    let div = null;

    if (application.jobble.actualMinutesWorked) {
      div = application.jobble.actualMinutesWorked / 60;
      application.jobble.hoursForShow = Math.floor(div);
      application.jobble.minutesForShow = application.jobble.actualMinutesWorked % 60;
    } else {
      div = application.jobble.jobbleDurationInMinutes / 60;
      application.jobble.hoursForShow = Math.floor(div);
      application.jobble.minutesForShow = application.jobble.jobbleDurationInMinutes % 60;
    }

    ////////console.log('application.jobble.minutesForShow');
    ////////console.dir(application.jobble.minutesForShow);

    _this.totalForIndividual(application, 2);
  }

  totalForIndividual(application, status) {
    var _this = this;

    switch (status) {
      case 1:
        _this.setTotalForActualMinutesWorked(application);
        break;
      case 2:
        _this.setTotalForJobbleDuration(application);
        break;
    }
  }

  setTotalForActualMinutesWorked(application) {
    var _this = this;

    ////////console.log('setTotalForActualMinutesWorkedsetTotalForActualMinutesWorked');
    application.jobble.totalCalculated = application.jobble.actualRevenue / 100;
  }

  setTotalForJobbleDuration(application) {
    var _this = this;

    application.jobble.totalCalculated = application.jobble.costOfJobble / 100;
  }

  totalHoursWorkedForEvent() {
    var _this = this;

    var div = _this.totalMinutesWorkedForEntireJob / 60;

    return Math.floor(div);
  }

  totalMinutesWorkedForEvent() {
    var _this = this;
    //console.log("where is this set......");
    //console.dir(_this.totalMinutesWorkedForEntireJob);

    return _this.totalMinutesWorkedForEntireJob % 60;
  }

  setRatingsToUI(application, status) {
    var _this = this;
    //////////console.log('setRatingsToUI');
    //////////console.dir(status);
    application.ratingValue = status;
  }

  writeReviewForJobbler(application) {
    var _this = this;
    //////////console.log('writeReviewForJobbler');
    //////////console.dir(application);

    _this.$timeout(function () {
      jQuery("#modal-add-review-jobbler-click").trigger("click");
    }, 100);
  }

  viewJobblerNote() {
    var _this = this;
    //////////console.log('view jobbler note');
  }

  loopShiftsForNote(application) {
    var _this = this;
    application.shift_count = 0;
    application.noteCount = 0;

    application.jobble.shifts.forEach(function (shift) {
      application.shift_count = application.shift_count + 1;

      if (shift.jobblerNote) {
        application.noteCount = application.noteCount + 1;
        application.hasNote = true;
      }

      if (shift.checkInTime || shift.checkOutTime || shift.autoCheckInTime || shift.autoCheckOutTime) {
        application.hasLocationData = true;
      }
    });
  }

  showMeTheNote(data, shift) {
    var _this = this;
    //////////console.log('showMeTheNote');
    //////////console.dir(data);
    //////////console.dir(shift);
  }

  toggleTip(data, shift, index) {
    //////////console.log('toggleTipOn');
    var _this = this;

    var id_index = index + 1;
    var selector = "#hide-me-for-tool-tip-" + id_index + ".hide-me-shifts";

    //////////console.log('what is the selector?');
    //////////console.dir(selector)
    //////////console.log('whats our jquery choices');
    //////////console.dir(jQuery(selector));

    if (shift.jobblerNote) {
      _this.$timeout(function () {
        jQuery(selector).show("slide", "fast");
      }, 100);
    }
  }

  toggleTipOff(data, shift, index) {
    //////////console.log('toggleTipOff');
    var _this = this;
    var _this = this;
    var id_index = index + 1;

    var selector = "#hide-me-for-tool-tip-" + id_index + ".hide-me-shifts";

    _this.$timeout(function () {
      jQuery(selector).hide("slide", "slide");
    }, 100);
  }

  formatAddressForMaps() {
    var _this = this;

    var city = _this.event.contactInfo.city;
    var street = _this.event.contactInfo.streetLine1;
    var state = _this.event.contactInfo.state;
    //var zipCode = _this.event.contactInfo.zipCode;
    var address = street + ", " + city + ", " + state;

    _this.address = address;
  }

  keepNoteActive() {
    var _this = this;
    //////////console.log('keepNoteActive');
  }

  clearMarkers() {
    var _this = this;

    for (var i = 0; i < _this.map.markers.length; i++) {
      _this.map.markers[i].setMap(null);
    }
  }

  setMarkerToMap(application) {
    var _this = this;

    try {
      _this.$timeout(function () {
        _this.mapHasLoaded = true;
      }, 1000);

      _this.$timeout(function () {
        _this.$maps.getMap({id: "mapIdd"}).then(
          function (map) {
            ////////console.log('what is the map at this point...........');
            ////////console.dir(map);
            ////////console.dir(map.markers);

            _this.map = map;

            if (map.markers) {
              _this.clearMarkers();
            }
          },
          function (data) {
            ////////console.log('error');
            ////////console.dir(data);
          }
        );
      }, 2000);
    } finally {
      ////////console.log('what is google at this point? -- this should happen after the marker');
      ////////console.dir(google);

      _this.$timeout(function () {
        _this.geocoder = new google.maps.Geocoder();

        _this.geocoder.geocode({address: _this.address}, function (results, status) {
          if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
            var locmrker = {};
            var location = results[0].geometry.location;
            var myLatLngEv = {
              lat: location.lat(),
              lng: location.lng(),
            };
            var image = "/app/vendor/images/icon-location.png";

            _this.centerLat = location.lat();
            _this.centerLng = location.lng();

            var marker = new google.maps.Marker({
              title: _this.event.name,
              icon: "/app/vendor/images/icon-location.png",
              position: myLatLngEv,
              id: null,
              showMe: true,
              checkin: null,
            });

            _this.positions.push(marker);
            _this.setCenterOfMap(marker, application);
          }
        });
      }, 3500);
    }
  }

  setCenterOfMap(marker, application) {
    var _this = this;

    _this.$timeout(function () {
      _this.zoom = 11;
      marker.setMap(_this.map);
      _this.setShiftMarkersOntoMap(application);
    }, 300);
  }

  toggleMarkers(shift, type) {
    var _this = this;

    if (type === 1) {
      ////////console.log('this is the shift...');
      ////////console.dir(shift);

      if (shift.toggleHasBeenSelectedCheckIn) {
        shift.toggleHasBeenSelectedCheckIn = false;
        _this.turnOffaGivenShiftsCheckIn(shift);
      } else {
        if (shift.checkInCoord.lat && shift.checkInCoord.lat !== 0) {
          shift.toggleHasBeenSelectedCheckIn = true;
          _this.turnOnaGivenShiftsCheckIn(shift);
        }
      }
    }

    if (type === 2) {
      ////////console.log('this is the shift...');
      ////////console.dir(shift);

      if (shift.toggleHasBeenSelectedCheckOut) {
        shift.toggleHasBeenSelectedCheckOut = false;
        _this.turnOffaGivenShiftsCheckOut(shift);
      } else {
        if (shift.checkOutCoord.lat) {
          shift.toggleHasBeenSelectedCheckOut = true;
          _this.turnOnaGivenShiftsCheckOut(shift);
        }
      }
    }
  }

  turnOnaGivenShiftsCheckOut(shift) {
    var _this = this;

    _this.positions.some(function (elem, index) {
      if (elem.id !== shift.id) {
        if (!elem.isSelected) {
          elem.showMe = false;
        }
      } else {
        if (elem.checkin) {
          /*elem.showMe = false;*/
          if (!elem.isSelected) {
            elem.showMe = false;
          }
        } else {
          elem.isSelected = true;
          elem.showMe = true;
        }
      }
    });
  }

  turnOnaGivenShiftsCheckIn(shift) {
    var _this = this;

    _this.positions.some(function (elem, index) {
      if (elem.id !== shift.id) {
        if (!elem.isSelected) {
          elem.showMe = false;
        }
      } else {
        if (!elem.checkin) {
          if (!elem.isSelected) {
            elem.showMe = false;
          }
        } else {
          elem.isSelected = true;
          elem.showMe = true;
        }
      }
    });
  }

  turnOffaGivenShiftsCheckOut(shift) {
    var _this = this;

    _this.positions.some(function (elem, index) {
      if (elem.id !== shift.id) {
        ////////console.log('not equal.....');
        /*
				if (!elem.isSelected) {
					elem.showMe = false;
				}
				*/
      } else {
        if (elem.checkin) {
          /*elem.showMe = false;*/
        } else {
          elem.isSelected = false;
          elem.showMe = false;
        }
      }
    });
  }

  turnOffaGivenShiftsCheckIn(shift) {
    var _this = this;

    _this.positions.some(function (elem, index) {
      if (elem.id !== shift.id) {
        ////////console.log('not equal.....');
        /*
				if (!elem.isSelected) {
					elem.showMe = false;
				}
				*/
      } else {
        if (!elem.checkin) {
          /*elem.showMe = false;*/
        } else {
          elem.isSelected = false;
          elem.showMe = false;
        }
      }
    });
  }

  formatPaymentInfoForPage(info) {
    var _this = this;
    _this.paymentMethodsFormatted = _this.$auth.formatPaymentMethods(info);
    _this.$timeout(function () {
      _this.paymentMethodsFormatted = _this.paymentMethodsFormatted;
    });
  }

  selectPaymentMethod(paymentMethod) {
    var _this = this;

    let paymentMethodFiltered = _this.paymentMethodsFormatted.filter(function (p) {
      return p.isChecked === true;
    });

    if (paymentMethodFiltered === true) {
      paymentMethodFiltered = false;
    }

    _this.cardHasBeenSelected = true;
    _this.selectedPaymentMethod = paymentMethod;

    if (_this.selectedPaymentMethod.stripeId) {
      _this.token = _this.selectedPaymentMethod.stripeId;
    } else if (_this.selectedPaymentMethod.cardToken) {
      _this.token = _this.selectedPaymentMethod.cardToken;
    }

    if (_this.selectedPaymentMethod.bankName) {
      _this.paying_with_bank = true;
      _this.paying_with_card = false;
    } else {
      _this.paying_with_bank = false;
      _this.paying_with_card = true;
    }

    _this.paymentMethods = _this.$auth.selectPaymentMethod(_this.paymentInfos, paymentMethod);
  }

  setShiftMarkersOntoMap(application) {
    ////////console.log('setShiftMarkersOntoMap');
    ////////console.dir(application);
    var _this = this;

    try {
      application.jobble.shifts.forEach(function (shift, index) {
        var mrker = {};
        var automrker = {};
        var markerOut = null;
        var marker = null;
        var automarkerin = null;

        var shiftCounter = index + 1;

        if (shift.checkInCoord) {
          if (shift.checkInCoord.lat) {
            mrker.jobbler = application.applicant.firstName + " " + application.applicant.lastName + " -- Manual Check In -- Shift #" + shiftCounter;
            mrker.checkInLat = shift.checkInCoord.lat;
            mrker.checkInLng = shift.checkInCoord.lng;
            mrker.manualCheckinImage = "/app/vendor/images/darkgreen_MarkerI.png";
            mrker.myLatLng = {
              lat: shift.checkInCoord.lat,
              lng: shift.checkInCoord.lng,
            };
            mrker.shiftId = shift.id;
            //////////console.log('mrker.myLatLngmrker.myLatLngmrker.myLatLngmrker.myLatLngmrker.myLatLng');
            //////////console.dir(mrker.myLatLng);
            marker = new google.maps.Marker({
              title: mrker.jobbler,
              icon: mrker.manualCheckinImage,
              position: mrker.myLatLng,
              id: mrker.shiftId,
              showMe: true,
              checkin: true,
            });
            _this.positions.push(marker);
            //marker.setMap(_this.map);
          }
        }

        if (shift.checkOutCoord) {
          if (shift.checkOutCoord.lat) {
            mrker.checkOutLat = shift.checkOutCoord.lat;
            mrker.jobblerOut =
              application.applicant.firstName + " " + application.applicant.lastName + " -- Manual Check Out -- Shift #" + shiftCounter;
            mrker.checkOutLng = shift.checkOutCoord.lng;
            mrker.shiftId = shift.id;
            mrker.manualCheckoutImage = "/app/vendor/images/red_MarkerO.png";
            mrker.myOutLatLng = {
              lat: shift.checkOutCoord.lat,
              lng: shift.checkOutCoord.lng,
            };
            markerOut = new google.maps.Marker({
              title: mrker.jobblerOut,
              icon: mrker.manualCheckoutImage,
              position: mrker.myOutLatLng,
              id: mrker.shiftId,
              showMe: true,
              checkin: false,
            });
            _this.positions.push(markerOut);
            //markerOut.setMap(_this.map);
          }
        }
      });
    } finally {
      ////////console.log('what are the poisitons');
      ////////console.dir(_this.positions);
    }
  }

  alignSideBar() {
    var _this = this;
    _this.$timeout(function () {
      if (_this.event.isCompleted || _this.event.isClosed || _this.event.isCancelled) {
        _this.showPayment = false;
        $("eventsidebar .jobs-complete-sidebar li:nth-child(5)").removeClass().addClass("active");
      } else {
        _this.showPayment = true;
        _this.$timeout(function () {
          $("eventsidebar .jobs-complete-sidebar li:nth-child(9)").removeClass().addClass("active");
        }, 500);
      }
    });
  }

  bulkSelector() {
    var _this = this;
    if (!_this.bulkCheck) {
      _this.checkAllJobblers();
      _this.bulkCheck = true;
    } else {
      _this.unCheckAllJobblers();
      _this.bulkCheck = false;
    }
  }

  checkAllJobblers() {
    var _this = this;
    _this.jobblers.forEach(function (j) {
      if (j.jobble.noShow || j.paymentToshiftHasBeenMade) {
      } else {
        if (!j.isCheckedForAction) {
          _this.applicationsForBulkUpdate.push(j);
          _this.applicationsForRatingUpdate.push(j);
        }

        j.isCheckedForAction = true;
      }
    });
  }

  unCheckAllJobblers() {
    var _this = this;
    _this.jobblers.forEach(function (j) {
      if (j.isCheckedForAction) {
        _this.applicationsForBulkUpdate.splice(0, 1);
        _this.applicationsForRatingUpdate.splice(0, 1);
      }
      j.isCheckedForAction = false;
    });
  }

  editAJobblersRatings(jobbler) {
    var _this = this;

    if (jobbler.jobble.noShow || jobbler.paymentToshiftHasBeenMade) {
      return;
    }

    try {
      let x = _this.jobblers.findIndex((obj) => obj.isEditingRating == true);

      if (x > -1) {
        _this.jobblers[x].isEditingRating = false;
      }
    } finally {
      _this.optionsRating.value = jobbler.ratingValue;
      jobbler.isEditingRating = true;

      _this.$timeout(function () {
        $(".table-responsive.table-responsive-payments table tbody tr td span.editing-rating-of-jobbler select").focus();
      }, 100);
    }
  }

  blurRatingEdit(jobbler) {
    var _this = this;

    jobbler.isEditingRating = false;
  }

  changeRatingEdit(jobbler) {
    var _this = this;

    jobbler.isEditingRating = false;
    jobbler.ratingValue = _this.optionsRating.value;
    _this.optionsRating.value = 5;

    _this.handleRatingsAndReview(jobbler, true);
  }

  triggerBulkModal() {
    var _this = this;
    _this.$timeout(function () {
      $("#modal-bulk-rating").modal();
    }, 100);
    //_this.$timeout(function(){
    //_this.unCheckAllJobblers();
    //_this.bulkCheck = false;
    //}, 400)
  }

  submitReviewBulkUpdate() {
    var _this = this;

    _this.loadingReviews = true;

    let r = _this.reviewForBulk;

    try {
      _this.jobblers.forEach(function (j) {
        if (j.isCheckedForAction) {
          j.ratingReview = r;
        }
      });
    } finally {
      _this.handleRatingsAndReview();
    }
  }

  submitRatingsBulkUpdate() {
    var _this = this;

    _this.loadingRatings = true;

    let r = _this.optionsRatingModal.value;

    try {
      _this.jobblers.forEach(function (j) {
        //////console.log('each bro');
        //////console.dir(j.isCheckedForAction);
        if (j.isCheckedForAction) {
          j.ratingValue = r;
        }
      });
    } finally {
      _this.handleRatingsAndReview();
      /*

			*/
    }
  }

  checkForAction(jobbler) {
    var _this = this;

    ////console.log('what is this');
    ////console.dir(jobbler.jobble.noShow);
    ////console.dir(jobbler.paymentToshiftHasBeenMade);

    if (jobbler.jobble.noShow || jobbler.paymentToshiftHasBeenMade) {
      return;
    }

    _this.bulkCheck = false;

    if (jobbler.isCheckedForAction) {
      jobbler.isCheckedForAction = false;
      _this.applicationsForBulkUpdate.splice(0, 1);
    } else {
      jobbler.isCheckedForAction = true;
      _this.applicationsForBulkUpdate.push(jobbler);
    }

    ////console.log('_this.applicationsForBulkUpdate');
    ////console.dir(_this.applicationsForBulkUpdate);
  }

  editAJobblersMinutes(application) {
    var _this = this;

    if (application.jobble.noShow || application.paymentToshiftHasBeenMade) {
      return;
    }

    application.isEditingMin = true;

    let initJobbleDurationVals = {};
    initJobbleDurationVals.hours = application.jobbleDurationData.hours;
    initJobbleDurationVals.minutes = application.jobbleDurationData.minutes;
    application.jobbleDurationDataInitVals = initJobbleDurationVals;

    _this.$timeout(function () {
      $(".table-responsive.table-responsive-payments table tbody tr td span.editing-rating-of-jobbler input").focus();
    }, 100);
  }

  editAJobblersHours(application) {
    var _this = this;

    if (application.jobble.noShow || application.paymentToshiftHasBeenMade) {
      return;
    }

    ////console.log('about to edit hours');
    ////console.dir(application);
    let initJobbleDurationVals = {};
    initJobbleDurationVals.hours = application.jobbleDurationData.hours;
    initJobbleDurationVals.minutes = application.jobbleDurationData.minutes;
    application.jobbleDurationDataInitVals = initJobbleDurationVals;
    //let initJobbleDurationVals = application.jobbleDurationData;
    //application.jobbleDurationDataInitVals = initJobbleDurationVals;

    application.isEditingHours = true;

    _this.$timeout(function () {
      $(".table-responsive.table-responsive-payments table tbody tr td span.editing-rating-of-jobbler input").focus();
    }, 100);

    return;
  }

  editAJobblersMin(application) {
    var _this = this;
    if (application.jobble.noShow || application.paymentToshiftHasBeenMade) {
      return;
    }

    application.isEditingMin = true;
  }

  enterMinsUpdated(application) {
    var _this = this;

    ////console.log('enterMinsUpdated');
    ////console.dir(application.jobbleDurationData.minutes);

    if (application.jobbleDurationData.minutes === null || angular.isUndefined(application.jobbleDurationData.minutes)) {
      application.jobbleDurationData.minutes = application.jobbleDurationDataInitVals.minutes;
      return;
    }

    if (application.jobbleDurationData.minutes > 59) {
      application.jobbleDurationData.minutes = 59;
    }

    let x = _this.jobblers.findIndex((obj) => obj.isEditingMin == true);

    if (x > -1) {
      _this.jobblers[x].isEditingMin = false;
    }

    _this.storeHoursForDBCall(application, true);
  }

  blurMinsUpdated(application) {
    var _this = this;

    if (application.jobbleDurationData.minutes === null || angular.isUndefined(application.jobbleDurationData.minutes)) {
      application.jobbleDurationData.minutes = application.jobbleDurationDataInitVals.minutes;
      return;
    }

    if (application.jobbleDurationData.minutes > 59) {
      application.jobbleDurationData.minutes = 59;
    }

    let x = _this.jobblers.findIndex((obj) => obj.isEditingMin == true);

    if (x > -1) {
      _this.jobblers[x].isEditingMin = false;
    }

    _this.storeHoursForDBCall(application, true);
  }

  enterHoursUpdated(application) {
    var _this = this;

    ////console.log('application');
    ////console.dir(application);
    ////console.dir(application.jobbleDurationData.hours);

    if (application.jobbleDurationData.hours === null || angular.isUndefined(application.jobbleDurationData.hours)) {
      //alert('no decimals are allowed');
      application.jobbleDurationData.hours = application.jobbleDurationDataInitVals.hours;
      return;
    }

    let x = _this.jobblers.findIndex((obj) => obj.isEditingHours == true);

    if (x > -1) {
      if (_this.jobblers[x].paymentToshiftHasBeenMade) {
        _this.jobblers[x].paymentToshiftHasBeenMade = false;
      }

      _this.jobblers[x].isEditingHours = false;
    }

    _this.storeHoursForDBCall(application, true);
  }

  blurHoursUpdated(application) {
    var _this = this;

    if (application.jobbleDurationData.hours === null || angular.isUndefined(application.jobbleDurationData.hours)) {
      //alert('no decimals are allowed');
      application.jobbleDurationData.hours = application.jobbleDurationDataInitVals.hours;
      return;
    }

    let x = _this.jobblers.findIndex((obj) => obj.isEditingHours == true);

    if (x > -1) {
      _this.jobblers[x].isEditingHours = false;
    }

    _this.storeHoursForDBCall(application, true);
  }

  editJobblerPay(application) {
    var _this = this;

    if (application.jobble.noShow || application.paymentToshiftHasBeenMade) {
      return;
    }

    application.isEditingPay = true;

    //////console.log('what do we have here');
    //////console.dir(application.jobble.totalCalculated);
    //console.log("do we have delivery");
    //console.dir(_this.delivery);

    if (_this.delivery) {
      application.jobble.totalCalculated = (application.jobble.payPerHour / 100).toFixed(2);
    } else {
      application.jobble.totalCalculated = application.jobble.totalCalculated.toFixed(2);
    }

    _this.$timeout(function () {
      $(".table-responsive.table-responsive-payments table tbody tr td span.editing-rating-of-jobbler input").focus();
    }, 100);
  }

  enterPayUpdated(application) {
    var _this = this;

    let x = _this.jobblers.findIndex((obj) => obj.isEditingPay == true);

    if (x > -1) {
      _this.jobblers[x].isEditingPay = false;
    }

    if (!_this.delivery) {
      let a = application.jobble.totalCalculated * 100;
      let y = application.jobble.payPerHour * 100;
      let min = (a / y) * 100 * 60;
      application.jobbleDurationData.minutes = Math.round(min % 60);
      application.jobbleDurationData.hours = Math.floor(min / 60);
      _this.storeHoursForDBCall(application, true);
    } else {
      application.jobble.payPerHour = application.jobble.totalCalculated * 100;
      _this.storePayPerHourForDelivery(application);
    }
  }

  storePayPerHourForDelivery(application) {
    var _this = this;
    //console.log("whats the data to store");
    let amount = application.jobble.payPerHour;
    let jobble_id = application.jobble.id;
    //console.log("what do we ahve here");
    //console.dir(amount);
    //console.dir(jobble_id);
    _this.$security.putPayPerHourUpdateForDelivery(jobble_id, amount).then(
      function (response) {
        //console.log("response from updating the pay per hour");
        //console.dir(response);
      },
      function (error) {
        //console.log("error");
        //console.dir(error);
      }
    );
  }

  blurPayUpdated(application) {
    var _this = this;

    ////////console.log('blurHoursUpdated');

    let x = _this.jobblers.findIndex((obj) => obj.isEditingPay == true);

    if (x > -1) {
      _this.jobblers[x].isEditingPay = false;
    }

    let a = application.jobble.totalCalculated * 100;
    let y = application.jobble.payPerHour * 100;
    let min = (a / y) * 100 * 60;

    application.jobbleDurationData.minutes = Math.round(min % 60);
    application.jobbleDurationData.hours = Math.floor(min / 60);
    _this.storeHoursForDBCall(application, true);

    //_this.totalAmountToBePaidOut();
  }

  setPaymentHistoryForCompletePage(application) {
    var _this = this;

    //////console.log('setPaymentHistoryForCompletePage');
    //////console.dir(application);
    application.paymentTotalAmount = 0;
    application.paymentTotalTransactions = 0;

    try {
      application.jobble.shifts.forEach(function (shift) {
        if (shift.paymentStats.number > 0) {
          ////console.log('we have payment stats here...');
          ////console.dir(application.applicant.firstName);
          ////console.dir(application.jobble.makeAdditionalPayment);

          if (!application.jobble.makeAdditionalPayment) {
            application.paymentToshiftHasBeenMade = true;
          }

          application.paymentTotalAmount = application.paymentTotalAmount + shift.paymentStats.amount;
          application.paymentTotalTransactions = application.paymentTotalTransactions + shift.paymentStats.number;
        }
      });
    } finally {
      _this.calcTimeWorked(application);
    }
  }

  slidePayments(jobbler, index) {
    var _this = this;

    if (jobbler.jobble.noShow || jobbler.paymentToshiftHasBeenMade) {
      return;
    }

    let id_index = index + 1;
    let selector = "#slide-toggle-for-complete-" + id_index + ".hide-row-that-has-pay-info";

    ////console.log('what is the jobbler');
    ////console.dir(jobbler);

    jobbler.jobble.shifts.sort(function (a, b) {
      return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
    });

    if (!jobbler.show) {
      jobbler.show = true;
      _this.$timeout(function () {
        jQuery(selector).show("fast");
      }, 100);
    } else {
      jobbler.show = false;
      _this.$timeout(function () {
        jQuery(selector).hide("fast");
      }, 100);
    }
  }

  confirmJobblerNoShow(application) {
    var _this = this;
    //////console.log('confirmJobblerNoShow');
    _this.$timeout(function () {
      $("#modal-mark-as-now-show").modal();
    });
    _this.dataModelForNoShow = application;
  }

  confirmJobblerNoShowCancel(application) {
    var _this = this;
    //////console.log('confirmJobblerNoShow');
    //console.log("confirmJobblerNoShowCancel");
    //console.dir(application.jobble);
    _this.$timeout(function () {
      $("#modal-mark-as-now-show-cancel").modal();
      _this.dataModelForNoShow = application;
    });
  }

  markJobblerAsANoShowFromMainPage() {
    var _this = this;
    _this.noShowButtonDiabled = true;
    _this.$security.markJobblerAsNoShowTrimmed(_this.dataModelForNoShow).then(
      function (response) {
        _this.noShowButtonDiabled = false;
        _this.jobblers.some(function (elem) {
          if (elem.jobble.id === response.data.id) {
            elem.noShowClass = "no-show-jobbler";
            elem.jobble.paidOutClass = "jobbler-is-no-show";
            elem.jobble.hoursForShow = 0;
            elem.jobble.minutesForShow = 0;
            elem.jobbleDurationData.hours = 0;
            elem.jobbleDurationData.minutes = 0;
            elem.jobble.totalCalculated = 0;
            elem.ratingValue = 1;
            //_this.minutePreview = 0;
            //_this.hourPreview = 0;
            elem.jobble.noShow = true;
            //console.log("ok jobble duration in minutes here");
            //console.dir(elem.jobble);
          }
        });
        _this.$timeout(function () {
          $("#modal-mark-as-now-show").modal("hide");
        });
      },
      function (data) {
        //_this.remain_loading_count--;
        _this.noShowButtonDiabled = false;
        _this.$timeout(function () {
          $("#modal-mark-as-now-show").modal("hide");
        });
        _this.$timeout(function () {
          alert("There appears to be an error marking this jobbler as a no show. Please refresh your page to view updated information.");
        }, 500);
      }
    );
  }

  markJobblerAsANoShowFromMainPageCancel() {
    var _this = this;
    _this.noShowButtonDiabled = true;
    //console.log("_this.dataModelForNoShow.jobble");
    //console.dir(_this.dataModelForNoShow.jobble);
    _this.dataModelForNoShow.jobble.actualMinutesWorked = _this.dataModelForNoShow.jobble.jobbleDurationInMinutes;
    _this.dataModelForNoShow.jobble.actualRevenue =
      (_this.dataModelForNoShow.jobble.actualMinutesWorked * _this.dataModelForNoShow.jobble.payPerHour) / 60;
    let app = _this.dataModelForNoShow;
    _this.$security.markJobblerAsNoShowCancel(_this.dataModelForNoShow).then(
      function (response) {
        _this.jobblers.some(function (elem) {
          _this.noShowButtonDiabled = false;
          if (elem.jobble.id === response.data.id) {
            //console.log("what is the element here");
            //console.dir(elem.jobble);
            elem.jobble.paidOutClass = "";
            elem.jobble.noShow = null;
            elem.noShowClass = null;
            elem.ratingValue = 5;
            elem.jobble.no_show_cancelled = true;
            if (elem.jobble.actualMinutesWorked && elem.jobble.actualMinutesWorked !== 0) {
              elem.jobbleDurationData.minutes = Math.round(elem.jobble.actualMinutesWorked % 60);
              elem.jobbleDurationData.hours = Math.floor(elem.jobble.actualMinutesWorked / 60);
              elem.jobble.totalCalculated = (elem.jobble.actualMinutesWorked * elem.jobble.payPerHour) / 60 / 100;
            } else {
              elem.jobbleDurationData.minutes = Math.round(elem.jobble.jobbleDurationInMinutes % 60);
              elem.jobbleDurationData.hours = Math.floor(elem.jobble.jobbleDurationInMinutes / 60);
              elem.jobble.totalCalculated = (elem.jobble.jobbleDurationInMinutes * elem.jobble.payPerHour) / 60 / 100;
            }

            elem.jobble.actualRevenue = null;

            //console.log("elem.jobble");
            //console.dir(elem.jobble);

            if (app.jobble.shifts.length === 1) {
              //console.log("do we have one shift?");

              _this.infoForDisplay = app;
              _this.markJobblerShowShowForShift(app.jobble.shifts[0], false, true, true, elem);
            }
          }
        });
        _this.$timeout(function () {
          $("#modal-mark-as-now-show-cancel").modal("hide");
        });
      },
      function (data) {
        _this.noShowButtonDiabled = false;
        alert("There appears to be an error marking this jobbler as a no show. Please refresh your page to view updated information.");
      }
    );
  }

  triggerBulkReview() {
    var _this = this;

    _this.reviewForBulk = null;
    _this.count = 0;

    _this.$timeout(function () {
      $("#modal-add-review-jobble-all").modal();
    });
  }

  submitReview() {
    var _this = this;

    ////console.log('subit review single');
    ////console.dir(_this.infoForDisplay);
    ////console.dir(_this.reviewForBulk);

    let x = _this.jobblers.findIndex((obj) => obj.id == _this.infoForDisplay.id);

    ////console.log('what is the review index');
    ////console.dir(x);

    if (x > -1) {
      _this.jobblers[x].ratingReview = _this.reviewForBulk;
    }

    _this.handleRatingsAndReview(_this.infoForDisplay, true);

    _this.$timeout(function () {
      $("#modal-add-review-jobbler .modal-header button.close").trigger("click");
    }, 1000);
  }

  calculateTotalsForDisplay() {
    var _this = this;

    _this.infoForDisplay.outstandingTotalsData = {};

    let hours = 0;
    let minutes = 0;
    let monies = 0;
    let minutes_being_totalled = 0;

    if (_this.shiftsWithOutPayments.length > 0) {
      try {
        _this.shiftsWithOutPayments.forEach(function (shift) {
          if (shift.noShow !== true) {
            if (shift.actualMinutesWorked || shift.actualMinutesWorked === 0) {
              minutes_being_totalled = minutes_being_totalled + shift.actualMinutesWorked;
            } else {
              let et = moment(shift.timeInterval.endTime);
              let st = moment(shift.timeInterval.startTime);
              let duration = moment.duration(et.diff(st));
              minutes_being_totalled = minutes_being_totalled + duration.asMinutes();
            }
          }
        });
      } finally {
        _this.infoForDisplay.outstandingTotalsData.hours = Math.floor(minutes_being_totalled / 60);
        _this.infoForDisplay.outstandingTotalsData.minutes = minutes_being_totalled % 60;
        let pay = _this.infoForDisplay.jobble.payPerHour;
        _this.infoForDisplay.outstandingTotalsData.monies = (pay * minutes_being_totalled) / 60 / 100;
      }
    } else {
      _this.infoForDisplay.outstandingTotalsData.hours = 0;
      _this.infoForDisplay.outstandingTotalsData.minutes = 0;
      _this.infoForDisplay.outstandingTotalsData.monies = 0.0;
    }
  }

  showHiddenTable() {
    var _this = this;

    ////console.log('showHiddenTable');

    if (_this.showingPayments) {
      _this.showingPayments = false;
      $("#modal-edit-shifts h3.shift-title.hidden-table").hide("fast");
      $("#modal-edit-shifts table.hidden-table").hide("fast");
    } else {
      _this.showingPayments = true;
      $("#modal-edit-shifts h3.shift-title.hidden-table").show("fast");
      $("#modal-edit-shifts table.hidden-table").show("fast");
    }
  }

  makeAnotherPayment(jobbler) {
    var _this = this;
    ////console.log('makeAnotherPayment');
    ////console.dir(jobbler);
  }

  markJobbleAsReadyForAdditionalPayments(application) {
    var _this = this;

    //////console.log('scanApplicantsAndMarkAsPaid');
    //////console.dir(application);
    application.paymentToshiftHasBeenMade = false;
    application.jobble.makeAdditionalPayment = true;
    //////console.dir(application);

    _this.$security.markJobblerAsPaidByShiftTrimmed(application).then(
      function (response) {
        ////console.log('markJobblerAsPaidByShiftTrimmed');
        ////console.dir(response.data);
        ////console.dir(application);

        if (response.data.actualMinutesWorked) {
          application.jobbleDurationData.minutes = response.data.actualMinutesWorked % 60;
          application.jobbleDurationData.hours = Math.floor(response.data.actualMinutesWorked / 60);
          application.jobble.totalCalculated = response.data.actualRevenue / 100;
        } else {
          application.jobbleDurationData.minutes = response.data.jobbleDurationInMinutes % 60;
          application.jobbleDurationData.hours = Math.floor(response.data.jobbleDurationInMinutes / 60);
          application.jobble.totalCalculated = response.data.costOfJobble / 100;
        }
      },
      function (error) {
        ////console.log('in error saving payment information');
      }
    );
  }

  markJobbleAsReadyForAdditionalPaymentsCancel(application) {
    var _this = this;

    //application.paymentToshiftHasBeenMade = true;
    application.jobble.makeAdditionalPayment = false;

    _this.$security.markJobblerAsPaidByShiftTrimmedCancel(application).then(
      function (response) {
        ////console.log('markJobblerAsPaidByShiftTrimmed');
        ////console.dir(response.data);
        ////console.dir(application);

        if (response.data.actualMinutesWorked) {
          application.jobbleDurationData.minutes = response.data.actualMinutesWorked % 60;
          application.jobbleDurationData.hours = Math.floor(response.data.actualMinutesWorked / 60);
          application.jobble.totalCalculated = response.data.actualRevenue / 100;
        } else {
          application.jobbleDurationData.minutes = response.data.jobbleDurationInMinutes % 60;
          application.jobbleDurationData.hours = Math.floor(response.data.jobbleDurationInMinutes / 60);
          application.jobble.totalCalculated = response.data.costOfJobble / 100;
        }
      },
      function (error) {
        ////console.log('in error saving payment information');
      }
    );
  }

  checkForPaymentInfo(application) {
    var _this = this;

    ////console.log('what do we have here');
    ////console.dir(application.applicant.undeletedPaymentInfos);

    if (!application.applicant.undeletedPaymentInfos) {
      //application.doesNotHavePaymentInfo = true;
    }
  }

  handleRatingsAndReview(data, singleUpdate) {
    var _this = this;
    let ratingsArray = [];
    try {
      if (!singleUpdate) {
        _this.jobblers.forEach(function (application) {
          if (application.isCheckedForAction) {
            ////console.log('we have the application ready to role.');
            ////console.dir(application);
            let ratingsObjForDB = {};
            ratingsObjForDB.ratingUser = _this.currentUser.id;
            ratingsObjForDB.ratedUser = application.applicant.id;
            ratingsObjForDB.rate = application.ratingValue;
            ratingsObjForDB.noteRateGiver = application.ratingReview;
            ratingsObjForDB.ratingType = 1;
            ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
            ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
            ratingsArray.push(ratingsObjForDB);
          }
        });
      } else {
        let ratingsObjForDB = {};
        ratingsObjForDB.ratingUser = _this.currentUser.id;
        ratingsObjForDB.ratedUser = data.applicant.id;
        ratingsObjForDB.rate = data.ratingValue;
        ratingsObjForDB.noteRateGiver = _this.reviewForBulk;
        ratingsObjForDB.ratingType = 1;
        ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
        ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
        ratingsArray.push(ratingsObjForDB);
      }
    } finally {
      _this.$events.rateOrReview(ratingsArray).then(
        function (response) {
          _this.$timeout(function () {
            _this.loadingRatings = false;
            _this.bulkRatingSuccess = true;
            //_this.unCheckAllJobblers();
            _this.bulkCheck = false;
            _this.bulkRatingSuccess = false;
            $("#modal-bulk-rating .modal-header button.close").trigger("click");
            $("#modal-add-review-jobble-all").modal("hide");
          }, 300);
        },
        function (error) {
          alert("There was an error submitting your review. Please try again later");
        }
      );
    }
  }

  getPaymentInfo(application) {
    var _this = this;
    if (application.applicant.undeletedPaymentInfos) {
      if (_this.currentUser.isAdmin && application.applicant.undeletedPaymentInfos.length === 0) {
        application.showPayInfoWarning = true;
      }
      if (_this.currentUser.isAdmin) {
        _this.findDuplicateJobbles();
      }
    }
  }

  findDuplicateJobbles() {
    var _this = this;

    //let arr = [9, 9, 111, 2, 3, 4, 4, 5, 7];

    let id_arr = [];

    try {
      _this.jobblers.forEach(function (application) {
        id_arr.push(application.jobble.id);
      });
    } catch (err) {
    } finally {
      let sorted_arr = id_arr.slice().sort();
      let results = [];

      for (var i = 0; i < sorted_arr.length - 1; i++) {
        if (sorted_arr[i + 1] == sorted_arr[i]) {
          results.push(sorted_arr[i]);
        }
      }

      _this.jobblers.forEach(function (application) {
        if (results.indexOf(application.jobble.id) > -1) {
          application.has_dupe = true;
          _this.dupe_error_prevent_payment = true;
        }
      });
    }
  }

  prepareShiftHours(application) {
    application.jobble.shifts.forEach(function (shift) {});
  }

  triggerBulkPay() {
    var _this = this;
    if (_this.cardHasBeenSelected) {
      _this.submitPaymentModal(1);
    } else {
      _this.noCardSelectedError = true;
      _this.$timeout(function () {
        let elementOffset = $("#credit-card-selection").offset().top;
        $("html,body").animate({scrollTop: elementOffset}, "slow");
      }, 300);
    }
  }

  setShiftStartTimesAndAmounts(application) {
    var _this = this;

    let pay_per_hour = application.jobble.payPerHour;
    let total_mins = 0;

    try {
      application.jobble.shifts.forEach(function (shift) {
        if (shift.noShow) {
          shift.shiftDurationInMinutes = 0;
          shift.shiftDurationInHours = 0;
        } else if (shift.paymentStats.number === 0) {
          if (shift.actualMinutesWorked || shift.actualMinutesWorked === 0) {
            total_mins = total_mins + shift.acutalMinutesWorked;
            shift.shiftDurationInMinutes = Math.round(shift.actualMinutesWorked % 60);
            shift.shiftDurationInHours = Math.floor(shift.actualMinutesWorked / 60);
            //shift.paymentStats.amountPaid = (((shift.actualMinutesWorked * pay_per_hour) / 60) / 100);
            shift.amountOwed = (shift.actualMinutesWorked * pay_per_hour) / 60 / 100;
          } else {
            let mins = shift.shiftDurationInMinutes;
            mins = shift.shiftDurationInHours * 60 + mins;
            shift.amountOwed = (mins * pay_per_hour) / 60 / 100;
            total_mins = total_mins + mins;
          }
        } else {
          let minutes = (shift.paymentStats.amount / pay_per_hour) * 60;
          shift.shiftDurationInMinutes = Math.round(minutes % 60);
          shift.shiftDurationInHours = Math.floor(minutes / 60);
          total_mins = total_mins + minutes;
          shift.amountOwed = shift.paymentStats.amount / 100;
        }
      });
    } finally {
      if (application.jobble.shifts.length === 1) {
      }
    }
  }

  setJobbleDurationsAndAmounts(application) {}

  calcOutstandingHours(application) {
    var _this = this;
    _this.setShiftStartTimesAndAmounts(application);
  }

  refreshList() {
    var _this = this;
    _this.remain_loading_count = 1;
    _this.jobblers = [];
    _this.getAcceptedJobblers();
  }

  fancyLoad(cls, length) {
    var _this = this;
    _this.$auth.fancyLoad(cls, length);
  }

  getAcceptedJobblers(offset) {
    var _this = this;
    _this.loading_jobblers = true;
    if (!offset) {
      offset = 0;
      _this.remain_loading_count--;
    }
    _this.$events.getAcceptedApplicationsTrimmedComplete(_this.event.subEvents[0].id, 10, offset).then(
      function (acceptedApplications) {
        var applicationsForLoc = [];
        _this.ratingsMap = [];
        if (acceptedApplications.data.length !== 0) {
          try {
            acceptedApplications.data.forEach(function (application, i) {
              application.displaySticky = true;
              var ratingsObjForDB = {};
              ratingsObjForDB.ratingUser = _this.currentUser.id;
              ratingsObjForDB.ratedUser = application.applicant.id;
              ratingsObjForDB.noteRateGiver = "";
              ratingsObjForDB.ratingType = 1;
              ratingsObjForDB.subEvent = _this.event.subEvents[0].id;
              ratingsObjForDB.ratingCompany = _this.currentUser.company.id;
              _this.ratingsArray.push(ratingsObjForDB);
              _this.sourcingPostTotal = _this.sourcingPostTotal + application.jobble.paymentStats.amount;

              if (application.jobble.paymentStats) {
                application.jobble.amountPaid = application.jobble.paymentStats.amount;
                application.jobble.averageAmount = application.jobble.paymentStats.amount / application.jobble.paymentStats.number;
              } else {
                application.jobble.amountPaid = 0;
                application.jobble.averageAmount = 0;
              }

              if (_this.$security.isUndefinedOrNull(application.rating.id)) {
                application.displaySticky = false;
                ratingsObjForDB.rate = 5;
                ratingsObjForDB.ratingValue = 5;
                application.ratingValue = 5;
              } else {
                application.displaySticky = true;
                ratingsObjForDB.ratingValue = application.rating.rate;
                application.ratingValue = application.rating.rate;
                _this.ratingsMap.push(application);
              }

              if (application.jobble.noShow !== true) {
                if (application.jobble.actualMinutesWorked === null) {
                  application.showActualMinutesWorked = false;
                } else {
                  application.jobble.jobbleDurationInMinutes = application.jobble.actualMinutesWorked;
                  application.showActualMinutesWorked = true;
                }
              } else {
                application.noShowClass = "no-show-jobbler";
                application.ratingValue = 1;
              }

              application.smallPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
              application.mediumPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
              application.largePic = application.applicant.filePROFILE_IMAGE1IMG_600x600;

              if (_this.$security.isUndefinedOrNull(application.smallPic)) {
                application.smallPic = application.mediumPic;
              }

              if (_this.$security.isUndefinedOrNull(application.applicant.lastName)) {
                application.applicant.lastShortName = "D.";
              } else {
                application.applicant.lastShortName = application.applicant.lastName.substring(0, 1) + ".";
              }
              applicationsForLoc.push(application);
              _this.format_names(application);
              _this.jobblers.push(application);
              _this.setPaymentHistoryForCompletePage(application);
              _this.loopShiftsForNote(application);
              _this.getPaymentInfo(application);
              _this.setJobbleDurationsAndAmounts(application);
              _this.fancyLoad(".table-responsive.table-responsive-payments table tbody tr.main-screen-data", _this.jobblers.length);
            });
          } finally {
            _this.sourcingPostTotals(_this.jobblers);
            _this.getAcceptedJobblers(_this.jobblers.length);
          }
        } else {
          _this.loading_jobblers = false;
          _this.sortJobblers();
        }
      },
      function (data) {
        _this.remain_loading_count--;
      }
    );
  }

  sortJobblers() {
    var _this = this;
    _this.jobblers.sort(function (a, b) {
      if (a.applicant.lastName < b.applicant.lastName) return -1;
      if (a.applicant.lastName > b.applicant.lastName) return 1;
      return 0;
    });
  }

  format_names(application) {
    var _this = this;
    application.applicant.firstName = application.applicant.firstName.toLowerCase();
    application.applicant.lastName = application.applicant.lastName.toLowerCase();
    let first_name_second_half = application.applicant.firstName.substring(1, application.applicant.firstName.length);
    let last_name_second_half = application.applicant.lastName.substring(1, application.applicant.lastName.length);
    application.applicant.firstName = application.applicant.firstName.charAt(0).toUpperCase() + first_name_second_half;
    application.applicant.lastName = application.applicant.lastName.charAt(0).toUpperCase() + last_name_second_half;
  }

  openJobModal() {
    var _this = this;
    _this.$timeout(function () {
      $("#re-open-job").modal();
    });
  }

  openJob() {
    var _this = this;

    let id = _this.$stateParams.eventId;

    _this.$events.reOpenEvent(id).then(
      function (response) {
        if (response.status === 200) {
          _this.event.isCompleted = false;
          _this.event.isClosed = false;
        } else {
          _this.$timeout(function () {
            $("#re-open-job").modal("toggle");
          });
        }
        _this.$timeout(function () {
          $("#re-open-job").modal("toggle");
        }, 300);
      },
      function (error) {}
    );
  }

  checkForDelivery() {
    var _this = this;
    if (_this.event.orderNumber) {
      _this.delivery = true;
    }
  }

  displayCreditCardModal() {
    var _this = this;
    let id = _this.event.id;
    _this.$timeout(function () {
      $("#modal-add-card").modal();
    });
  }

  displayBankModal() {
    var _this = this;
    let id = _this.event.id;
    _this.$timeout(function () {
      $("#modal-add-account").modal();
    });
  }

  getLatestInfo() {
    var _this = this;
    console.log("what is the user");
    console.dir(_this.currentUser.access_token);
    let t = _this.currentUser.access_token;
    _this.$auth.validateUserByToken(t).then(
      function (resp) {
        console.log("new user");
        console.dir(resp.data);
        _this.currentUser = resp.data;
        if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
          _this.currentUser.isAdmin = true;
        }
      },
      function (error) {
        console.log("error");
        console.dir(error);
      }
    );
  }

  expandPaymentTable() {
    var _this = this;

    if (!_this.table_expanded) {
      _this.table_expanded = true;
      _this.$timeout(function () {
        $(".side-bar-complete").addClass("side-bar-complete-hide");
        $(".main-page-complete").addClass("main-page-complete-expanded");
      }, 100);
    } else {
      _this.table_expanded = false;
      _this.$timeout(function () {
        $(".side-bar-complete").removeClass("side-bar-complete-hide");
        $(".main-page-complete").removeClass("main-page-complete-expanded");
      }, 100);
    }
  }

  addUserToTeamModal(application) {
    var _this = this;
    console.log("addUserToTeamModal");
    console.dir(application);
    _this.user_to_add = application.applicant;
    console.log("_this.user_to_add");
    console.dir(_this.user_to_add);
    _this.submitting = false;
    _this.$timeout(function () {
      $("#modal-add-to-team-jobbler").modal();
    }, 300);
    _this.loadTeams();
  }

  loadTeams() {
    var _this = this;
    var teamsSimple = [];

    _this.add_users_to_team_ui.loading_teams = true;
    _this.$companies.getTeamsSimple().then(
      function (response) {
        console.log("getTeamsSimple");
        console.dir(response);
        if (response.data.length > 0) {
          try {
            response.data.forEach(function (team, index) {
              var teamsObj = {};
              teamsObj.name = team.name;
              teamsObj.id = team.id;
              teamsSimple.push(teamsObj);
            });
          } finally {
            console.log("what are the teams");
            console.dir(teamsSimple);
            _this.teams_for_modal = teamsSimple;
            _this.add_users_to_team_ui.dropdown_placeholder = teamsSimple[0].id;
            _this.$timeout(function () {
              _this.add_users_to_team_ui.loading_teams = false;
            }, 500);
          }
        } else {
          _this.add_users_to_team_ui.loading_teams = false;
        }
      },
      function (data) {
        _this.add_user_to_team_error = "There was an error";
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  teamsChanged() {
    var _this = this;
    console.log("teamsChanged");
    console.dir(_this.add_users_to_team_ui.dropdown_placeholder);
  }

  submitTeamAdd() {
    var _this = this;
    console.log("submitTeamAdd");
    console.dir(_this.user_to_add);
    console.dir(_this.add_users_to_team_ui.dropdown_placeholder);
    _this.submitting = true;
    let circle = parseInt(_this.add_users_to_team_ui.dropdown_placeholder, 10);
    let email = _this.user_to_add.email;
    _this.$companies.updateCloudWithNewUser(circle, email).then(
      function (response) {
        if (response.data.status === "error") {
          alert("error adding user to team");
        } else {
          console.log("update cloud resp");
          console.dir(response);
          _this.success = "Jobbler was successfully added to team!";
          _this.$timeout(function () {
            $("#modal-add-to-team-jobbler").modal("toggle");
          }, 1500);
        }
      },
      function (error) {
        console.log("adding user error");
        console.dir(error);
        _this.submitting = false;
      }
    );
  }

  closeTeamAdd() {
    var _this = this;
    console.log("closeTeamAdd");
  }

  do_we_have_teams() {
    var _this = this;
    console.log("have the teams loaded");
    console.dir(this.$rootScope.teamsSimple);
    _this.loadTeams();
  }
}

EventcompleteController.$inject = [
  "$http",
  "$localStorage",
  "$scope",
  "$state",
  "auth",
  "companies",
  "events",
  "$stateParams",
  "security",
  "$rootScope",
  "env",
  "$timeout",
  "$location",
  "ngProgressFactory",
  "common",
  "NgMap",
  "tracking",
];

export default EventcompleteController;



// WEBPACK FOOTER //
// ./client/app/components/eventcomplete/eventcomplete.controller.js